import { Component, OnInit, OnDestroy, ViewChild, Input, AfterViewInit, ElementRef, ViewChildren, QueryList, HostListener, TemplateRef, Output, EventEmitter, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomInputComponent } from '../../custom-input/custom-input.component';
import { NgbActiveModal, NgbModal, NgbTooltip, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { debounceTime, Subject, Subscription, switchMap, of, EMPTY, retry, from, filter } from 'rxjs';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TitleCasePipe, NgIf, CommonModule } from '@angular/common';
import { CustomChipComponent, ChipItem } from '../../custom-chip/custom-chip.component';
import { OpenaiService } from 'src/app/openai/openai.service';
import { RequestServiceService } from '../request-service.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HireSuggestionsListComponent } from '../hire-suggestions-list/hire-suggestions-list.component';
import { FilterStoreService } from '../store/filter-store.service';
import { GlobalService } from 'src/app/_services/global.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MultiSelectModule } from 'primeng/multiselect';
import * as _ from 'underscore';
import { AggregateRequestStoreService } from '../store/aggregate-request-store.service';
import { ActivatedRoute, Router } from '@angular/router';
import cjson from 'compressed-json';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { FilterResponseMapperServiceService } from '../filter-response-mapper-service.service';
import { EuropeAccessModalComponent } from 'src/app/europe-access-modal/europe-access-modal.component';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { ProjectAggregateService } from 'src/app/projects/services/project-aggregate.service';
import { AggregateService } from 'src/app/projects/services/aggregate.service';
import { ProjectAggregateStoreService } from 'src/app/projects/services/project-aggregate-store.service';
import { ProjectFilterStoreService } from 'src/app/projects/services/project-filter-store.service';
import { FilterConstant } from 'src/app/projects/constant/filterConstant';
import { EventService } from 'src/app/projects/services/event.service';
import { PROJECT_TAB_CONSTANTS } from '../../projects/constant/projectConstants';
import { UploadCandidateService } from 'src/app/projects/services/upload-candidate.service';



// Shape of the payload returned by getJobTitleAndSkillSuggestions
interface SuggestionPayload {
  [field: string]: any; // replace with your actual response shape
}

@Component({
  selector: 'app-hire-filter',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatOptionModule,
    TitleCasePipe,
    MatTooltipModule,
    CustomChipComponent,
    HireSuggestionsListComponent,
    CommonModule,
    AutoCompleteModule,
    MultiSelectModule,
    NgbTooltipModule,
    NgbTooltip
  ],
  templateUrl: './hire-filter.component.html',
  styleUrl: './hire-filter.component.scss',
  standalone: true,
})
export class HireFilterComponent implements OnInit, OnDestroy {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChildren('sectionRef') sectionRefs!: QueryList<ElementRef<HTMLDivElement>>;

  activeTab: string = '1';
  isScrollingProgrammatically = false;
  private scrollTimeout: any;

  projectnumber: string = '';

  @ViewChild('subject') subject!: CustomInputComponent;

  filterGroups: any[] = [
    {
      name: 'Keyboard and Boolean Search', id: 1, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.381 3.51848C12.6081 3.61963 12.7857 3.80682 12.8747 4.03888C12.9638 4.27094 12.9571 4.52888 12.856 4.75598L7.85601 16.006C7.80767 16.121 7.73686 16.2252 7.64771 16.3125C7.55857 16.3999 7.45289 16.4685 7.33688 16.5144C7.22087 16.5604 7.09685 16.5827 6.9721 16.5801C6.84735 16.5775 6.72438 16.55 6.61039 16.4992C6.4964 16.4485 6.39369 16.3755 6.30828 16.2845C6.22287 16.1935 6.15647 16.0864 6.11299 15.9695C6.06951 15.8525 6.04981 15.7281 6.05505 15.6034C6.06029 15.4787 6.09037 15.3564 6.14351 15.2435L11.1435 3.99347C11.2447 3.76642 11.4319 3.58883 11.6639 3.49976C11.896 3.41069 12.1539 3.41742 12.381 3.51848ZM5.62226 6.48723C5.80792 6.65226 5.92048 6.88422 5.93525 7.13218C5.95001 7.38014 5.86577 7.62383 5.70101 7.80973L3.75351 9.99973L5.70101 12.1897C5.86611 12.3757 5.95056 12.6197 5.9358 12.8679C5.92103 13.1162 5.80825 13.3484 5.62226 13.5135C5.53017 13.5952 5.42288 13.658 5.30652 13.6983C5.19016 13.7386 5.067 13.7556 4.94408 13.7483C4.69583 13.7335 4.46361 13.6207 4.29851 13.4347L1.79851 10.6222C1.64616 10.4507 1.56201 10.2292 1.56201 9.99973C1.56201 9.77028 1.64616 9.54879 1.79851 9.37723L4.29851 6.56473C4.38037 6.47233 4.47966 6.39702 4.59069 6.3431C4.70173 6.28918 4.82232 6.25771 4.94554 6.25051C5.06877 6.24331 5.1922 6.26051 5.30876 6.30114C5.42532 6.34176 5.5327 6.405 5.62476 6.48723M14.3798 6.48723C14.4718 6.40538 14.579 6.34246 14.6953 6.30206C14.8116 6.26166 14.9348 6.24457 15.0577 6.25176C15.1806 6.25896 15.3009 6.2903 15.4117 6.344C15.5225 6.3977 15.6217 6.4727 15.7035 6.56473L18.2035 9.37723C18.3559 9.54879 18.44 9.77028 18.44 9.99973C18.44 10.2292 18.3559 10.4507 18.2035 10.6222L15.7035 13.4347C15.5384 13.6207 15.3062 13.7335 15.0579 13.7483C14.8097 13.763 14.5657 13.6786 14.3798 13.5135C14.1938 13.3484 14.081 13.1162 14.0662 12.8679C14.0515 12.6197 14.1359 12.3757 14.301 12.1897L16.2448 9.99973L14.2998 7.80973C14.135 7.62383 14.0508 7.38014 14.0655 7.13218C14.0803 6.88422 14.1941 6.65226 14.3798 6.48723Z" fill="#484B59"/>
</svg>`},
    {
      name: 'Role & Experience', id: 2, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.04162 4.55059V5.73392L4.62996 5.84892C4.14498 5.88796 3.6871 6.08847 3.32952 6.41841C2.97193 6.74834 2.7353 7.18865 2.65746 7.66892C2.62301 7.88392 2.59135 8.0992 2.56246 8.31476C2.55597 8.36691 2.56609 8.41979 2.59137 8.46586C2.61666 8.51194 2.65582 8.54888 2.70329 8.57142L2.76746 8.60142C7.29162 10.7431 12.7091 10.7431 17.2325 8.60142L17.2966 8.57142C17.3439 8.54875 17.3829 8.51176 17.4081 8.46569C17.4332 8.41962 17.4432 8.36682 17.4366 8.31476C17.4084 8.09904 17.377 7.88374 17.3425 7.66892C17.2646 7.18865 17.028 6.74834 16.6704 6.41841C16.3128 6.08847 15.8549 5.88796 15.37 5.84892L13.9583 5.73476V4.55142C13.9584 4.20213 13.8331 3.86442 13.6052 3.59969C13.3774 3.33496 13.062 3.16082 12.7166 3.10892L11.7 2.95642C10.5729 2.78796 9.42703 2.78796 8.29996 2.95642L7.28329 3.10892C6.93802 3.1608 6.62282 3.33482 6.39497 3.59937C6.16711 3.86393 6.04174 4.20144 6.04162 4.55059ZM11.5141 4.19226C10.5102 4.04232 9.48967 4.04232 8.48579 4.19226L7.46912 4.34476C7.4198 4.35214 7.37476 4.37697 7.34219 4.41474C7.30961 4.45251 7.29167 4.50072 7.29162 4.55059V5.64642C9.09571 5.54339 10.9042 5.54339 12.7083 5.64642V4.55059C12.7082 4.50072 12.6903 4.45251 12.6577 4.41474C12.6252 4.37697 12.5801 4.35214 12.5308 4.34476L11.5141 4.19226Z" fill="#484B59"/>
  <path d="M17.5982 10.0588C17.5966 10.0319 17.5884 10.0057 17.5744 9.98264C17.5604 9.95955 17.541 9.94021 17.5179 9.92627C17.4948 9.91234 17.4686 9.90423 17.4417 9.90263C17.4147 9.90104 17.3878 9.90602 17.3632 9.91714C12.7207 11.973 7.27904 11.973 2.63654 9.91714C2.61194 9.90602 2.58501 9.90104 2.55806 9.90263C2.53112 9.90423 2.50496 9.91234 2.48184 9.92627C2.45873 9.94021 2.43934 9.95955 2.42535 9.98264C2.41136 10.0057 2.40319 10.0319 2.40154 10.0588C2.31714 11.6542 2.4029 13.2541 2.65737 14.8313C2.73505 15.3117 2.9716 15.7522 3.3292 16.0823C3.6868 16.4124 4.14478 16.6131 4.62987 16.6521L6.18987 16.7771C8.7257 16.9821 11.2732 16.9821 13.8099 16.7771L15.3699 16.6521C15.855 16.6131 16.3129 16.4124 16.6705 16.0823C17.0281 15.7522 17.2647 15.3117 17.3424 14.8313C17.5974 13.2521 17.684 11.6521 17.5982 10.0596" fill="#484B59"/>
</svg>
`},
   {
      name: 'Location', id: 5, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10.0002 1.66602C6.32524 1.66602 3.33357 4.65768 3.33357 8.33268C3.30857 13.6993 9.26691 17.9993 9.51691 18.1827C9.65857 18.2827 9.83357 18.341 10.0002 18.341C10.1669 18.341 10.3419 18.291 10.4836 18.1827C10.7336 17.9993 16.6919 13.7077 16.6669 8.33268C16.6669 4.65768 13.6752 1.66602 10.0002 1.66602ZM10.0002 11.666C8.15857 11.666 6.66691 10.1743 6.66691 8.33268C6.66691 6.49102 8.15857 4.99935 10.0002 4.99935C11.8419 4.99935 13.3336 6.49102 13.3336 8.33268C13.3336 10.1743 11.8419 11.666 10.0002 11.666Z" fill="#484B59"/>
</svg>`},

    {
      name: 'Skills & Expertise', id: 4, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.381 3.51848C12.6081 3.61963 12.7857 3.80682 12.8747 4.03888C12.9638 4.27094 12.9571 4.52888 12.856 4.75598L7.85601 16.006C7.80767 16.121 7.73686 16.2252 7.64771 16.3125C7.55857 16.3999 7.45289 16.4685 7.33688 16.5144C7.22087 16.5604 7.09685 16.5827 6.9721 16.5801C6.84735 16.5775 6.72438 16.55 6.61039 16.4992C6.4964 16.4485 6.39369 16.3755 6.30828 16.2845C6.22287 16.1935 6.15647 16.0864 6.11299 15.9695C6.06951 15.8525 6.04981 15.7281 6.05505 15.6034C6.06029 15.4787 6.09037 15.3564 6.14351 15.2435L11.1435 3.99347C11.2447 3.76642 11.4319 3.58883 11.6639 3.49976C11.896 3.41069 12.1539 3.41742 12.381 3.51848ZM5.62226 6.48723C5.80792 6.65226 5.92048 6.88422 5.93525 7.13218C5.95001 7.38014 5.86577 7.62383 5.70101 7.80973L3.75351 9.99973L5.70101 12.1897C5.86611 12.3757 5.95056 12.6197 5.9358 12.8679C5.92103 13.1162 5.80825 13.3484 5.62226 13.5135C5.53017 13.5952 5.42288 13.658 5.30652 13.6983C5.19016 13.7386 5.067 13.7556 4.94408 13.7483C4.69583 13.7335 4.46361 13.6207 4.29851 13.4347L1.79851 10.6222C1.64616 10.4507 1.56201 10.2292 1.56201 9.99973C1.56201 9.77028 1.64616 9.54879 1.79851 9.37723L4.29851 6.56473C4.38037 6.47233 4.47966 6.39702 4.59069 6.3431C4.70173 6.28918 4.82232 6.25771 4.94554 6.25051C5.06877 6.24331 5.1922 6.26051 5.30876 6.30114C5.42532 6.34176 5.5327 6.405 5.62476 6.48723M14.3798 6.48723C14.4718 6.40538 14.579 6.34246 14.6953 6.30206C14.8116 6.26166 14.9348 6.24457 15.0577 6.25176C15.1806 6.25896 15.3009 6.2903 15.4117 6.344C15.5225 6.3977 15.6217 6.4727 15.7035 6.56473L18.2035 9.37723C18.3559 9.54879 18.44 9.77028 18.44 9.99973C18.44 10.2292 18.3559 10.4507 18.2035 10.6222L15.7035 13.4347C15.5384 13.6207 15.3062 13.7335 15.0579 13.7483C14.8097 13.763 14.5657 13.6786 14.3798 13.5135C14.1938 13.3484 14.081 13.1162 14.0662 12.8679C14.0515 12.6197 14.1359 12.3757 14.301 12.1897L16.2448 9.99973L14.2998 7.80973C14.135 7.62383 14.0508 7.38014 14.0655 7.13218C14.0803 6.88422 14.1941 6.65226 14.3798 6.48723Z" fill="#484B59"/>
</svg>`},
 {
      name: 'Company', id: 3, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M6 2C4.89688 2 4 2.89688 4 4V16C4 17.1031 4.89688 18 6 18H14C15.1031 18 16 17.1031 16 16V4C16 2.89688 15.1031 2 14 2H6ZM9.5 13H10.5C11.0531 13 11.5 13.4469 11.5 14V16.5H8.5V14C8.5 13.4469 8.94688 13 9.5 13ZM7 5.5C7 5.225 7.225 5 7.5 5H8.5C8.775 5 9 5.225 9 5.5V6.5C9 6.775 8.775 7 8.5 7H7.5C7.225 7 7 6.775 7 6.5V5.5ZM11.5 5H12.5C12.775 5 13 5.225 13 5.5V6.5C13 6.775 12.775 7 12.5 7H11.5C11.225 7 11 6.775 11 6.5V5.5C11 5.225 11.225 5 11.5 5ZM7 9.5C7 9.225 7.225 9 7.5 9H8.5C8.775 9 9 9.225 9 9.5V10.5C9 10.775 8.775 11 8.5 11H7.5C7.225 11 7 10.775 7 10.5V9.5ZM11.5 9H12.5C12.775 9 13 9.225 13 9.5V10.5C13 10.775 12.775 11 12.5 11H11.5C11.225 11 11 10.775 11 10.5V9.5C11 9.225 11.225 9 11.5 9Z" fill="#484B59"/>
</svg>`},
    {
      name: 'Education', id: 6, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M17.8751 7.17495L10.3751 3.42495C10.2599 3.36769 10.133 3.33789 10.0043 3.33789C9.87562 3.33789 9.7487 3.36769 9.63346 3.42495L4.63346 5.92495L2.13346 7.17495L1.30013 7.59161C1.1627 7.66086 1.04713 7.76682 0.966233 7.89773C0.885333 8.02864 0.842263 8.17939 0.841797 8.33328V13.3333H2.50846V8.84995L9.63346 12.4166C9.75013 12.4749 9.87513 12.5083 10.0085 12.5083C10.1418 12.5083 10.2668 12.4749 10.3835 12.4166L17.8835 8.66662C18.1668 8.52495 18.3418 8.23328 18.3418 7.92495C18.3418 7.61662 18.1668 7.32495 17.8835 7.18328L17.8751 7.17495Z" fill="#484B59"/>
  <path d="M9.99984 14.166C9.6165 14.166 9.22484 14.0743 8.88317 13.8993L4.1665 11.541V12.866C4.1665 14.5827 6.7665 16.666 9.99984 16.666C13.2332 16.666 15.8332 14.591 15.8332 12.866V11.541L11.1165 13.8993C10.7748 14.0743 10.3832 14.166 9.99984 14.166Z" fill="#484B59"/>
</svg>`},
    {
      name: 'Profile / Identity', id: 7, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M9.125 16.2923C9.40278 16.459 9.69444 16.539 10 16.5323C10.3056 16.5256 10.5972 16.4387 10.875 16.2715L14.6667 13.959C13.9722 13.4729 13.2292 13.1084 12.4375 12.8657C11.6458 12.6229 10.8333 12.5012 10 12.5007C9.16667 12.5001 8.35083 12.6218 7.5525 12.8657C6.75417 13.1095 6.00056 13.467 5.29167 13.9382L9.125 16.2923ZM12.0625 9.97982C12.6319 9.41037 12.9167 8.72287 12.9167 7.91732C12.9167 7.11176 12.6319 6.42426 12.0625 5.85482C11.4931 5.28537 10.8056 5.00065 10 5.00065C9.19444 5.00065 8.50694 5.28537 7.9375 5.85482C7.36806 6.42426 7.08333 7.11176 7.08333 7.91732C7.08333 8.72287 7.36806 9.41037 7.9375 9.97982C8.50694 10.5493 9.19444 10.834 10 10.834C10.8056 10.834 11.4931 10.5493 12.0625 9.97982ZM9.125 18.2298L3.29167 14.6465C3.04167 14.4937 2.84722 14.2923 2.70833 14.0423C2.56944 13.7923 2.5 13.5215 2.5 13.2298V6.77148C2.5 6.47982 2.56944 6.20898 2.70833 5.95898C2.84722 5.70898 3.04167 5.5076 3.29167 5.35482L9.125 1.77148C9.40278 1.60482 9.69444 1.52148 10 1.52148C10.3056 1.52148 10.5972 1.60482 10.875 1.77148L16.7083 5.35482C16.9583 5.5076 17.1528 5.70898 17.2917 5.95898C17.4306 6.20898 17.5 6.47982 17.5 6.77148V13.2298C17.5 13.5215 17.4306 13.7923 17.2917 14.0423C17.1528 14.2923 16.9583 14.4937 16.7083 14.6465L10.875 18.2298C10.5972 18.3965 10.3056 18.4798 10 18.4798C9.69444 18.4798 9.40278 18.3965 9.125 18.2298Z" fill="#484B59"/>
</svg>`},
    {
      name: 'Power Filters', id: 8, icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M13.3333 12.5C14.4217 12.5 15.3483 13.1958 15.6917 14.1667H16.6667C16.8877 14.1667 17.0996 14.2545 17.2559 14.4107C17.4122 14.567 17.5 14.779 17.5 15C17.5 15.221 17.4122 15.433 17.2559 15.5893C17.0996 15.7455 16.8877 15.8333 16.6667 15.8333H15.6917C15.5195 16.3213 15.2002 16.7438 14.7778 17.0427C14.3554 17.3415 13.8508 17.502 13.3333 17.502C12.8159 17.502 12.3112 17.3415 11.8888 17.0427C11.4664 16.7438 11.1472 16.3213 10.975 15.8333H3.33333C3.11232 15.8333 2.90036 15.7455 2.74408 15.5893C2.5878 15.433 2.5 15.221 2.5 15C2.5 14.779 2.5878 14.567 2.74408 14.4107C2.90036 14.2545 3.11232 14.1667 3.33333 14.1667H10.975C11.1474 13.679 11.4668 13.2569 11.8892 12.9584C12.3116 12.6599 12.8161 12.4997 13.3333 12.5ZM6.66667 7.5C7.15749 7.49993 7.63748 7.64435 8.04678 7.91524C8.45608 8.18613 8.77658 8.57151 8.96833 9.02333L9.02417 9.16667H16.6667C16.8791 9.1669 17.0834 9.24823 17.2378 9.39404C17.3923 9.53985 17.4852 9.73913 17.4976 9.95116C17.5101 10.1632 17.4411 10.372 17.3048 10.5349C17.1685 10.6977 16.9751 10.8024 16.7642 10.8275L16.6667 10.8333H9.025C8.857 11.3086 8.54931 11.722 8.14228 12.0193C7.73524 12.3166 7.24786 12.484 6.74404 12.4995C6.24022 12.515 5.74348 12.3779 5.31894 12.1061C4.8944 11.8344 4.56189 11.4407 4.365 10.9767L4.30833 10.8333H3.33333C3.12093 10.8331 2.91664 10.7518 2.76219 10.606C2.60775 10.4602 2.5148 10.2609 2.50236 10.0488C2.48991 9.8368 2.5589 9.62802 2.69522 9.46514C2.83155 9.30226 3.02492 9.19759 3.23583 9.1725L3.33333 9.16667H4.30833C4.48074 8.67904 4.80014 8.25688 5.22252 7.95838C5.64489 7.65988 6.14946 7.49973 6.66667 7.5ZM13.3333 2.5C14.4217 2.5 15.3483 3.19583 15.6917 4.16667H16.6667C16.8877 4.16667 17.0996 4.25446 17.2559 4.41074C17.4122 4.56703 17.5 4.77899 17.5 5C17.5 5.22101 17.4122 5.43298 17.2559 5.58926C17.0996 5.74554 16.8877 5.83333 16.6667 5.83333H15.6917C15.5195 6.32128 15.2002 6.74381 14.7778 7.04268C14.3554 7.34155 13.8508 7.50204 13.3333 7.50204C12.8159 7.50204 12.3112 7.34155 11.8888 7.04268C11.4664 6.74381 11.1472 6.32128 10.975 5.83333H3.33333C3.11232 5.83333 2.90036 5.74554 2.74408 5.58926C2.5878 5.43298 2.5 5.22101 2.5 5C2.5 4.77899 2.5878 4.56703 2.74408 4.41074C2.90036 4.25446 3.11232 4.16667 3.33333 4.16667H10.975C11.1474 3.67904 11.4668 3.25688 11.8892 2.95838C12.3116 2.65988 12.8161 2.49973 13.3333 2.5Z" fill="#484B59"/>
</svg>`}
  ]

  status = 'current';

  // ─── Typeahead state ───────────────────────────────────────────────────────
  jobTitleControl: FormControl = new FormControl('');
  jobTitleList: any[] = [];
  showJobTitleLoader = false;
  pastJobTitleControl: FormControl = new FormControl('');
  skillsControl: FormControl = new FormControl('');
  booleanQueryControl: FormControl = new FormControl('');
  pastjobTitleList: any[] = [];
  companyControl: FormControl = new FormControl('');
  companyList: any[] = [];
  showCompanyLoader = false;
  industryControl: FormControl = new FormControl('');
  industryList: any[] = [];
  showIndustryLoader = false;
  skillsList: any[] = [];
  showSkillsLoader = false;
  functionControl: FormControl = new FormControl('');
  functionList: any[] = [];
  showFunctionLoader = false;
  locationControl: FormControl = new FormControl('');
  locationList: any[] = [];
  showLocationLoader = false;
  educationControl: FormControl = new FormControl('');
  educationList: any[] = [];
  showEducationLoader = false;
  schoolControl: FormControl = new FormControl('');
  schoolList: any[] = [];
  showSchoolLoader = false;
  fieldOfStudyControl: FormControl = new FormControl('');
  fieldOfStudyList: any[] = [];
  showFieldOfStudyLoader = false;
  seniorityControl: FormControl = new FormControl(null);
  seniorityList: any[] = GlobalService.seniorityLevels;
  jobStatus: FormControl = new FormControl('Current');
  fromYearsControl: FormControl = new FormControl('');
  toYearsControl: FormControl = new FormControl('');
  experienceStatus: FormControl = new FormControl('Total');
  companyStatus: FormControl = new FormControl('Current or Past');
  companysizeControl: FormControl = new FormControl('');
  currentFromYearsControl: FormControl = new FormControl('');
  currentToYearsControl: FormControl = new FormControl('');
  genderFormControl: FormControl = new FormControl('All');
highlightSelectedControl: FormControl = new FormControl(null);
  educationLocationControl: FormControl = new FormControl('');
  showSchoolLocationLoader: boolean = false;
  schoolLocationControl: FormControl = new FormControl('');
  schoolLocationList: any[] = [];
  fromgraduationyearControl: FormControl = new FormControl('');
  tograduationyearControl: FormControl = new FormControl('');
  industryStatus: FormControl = new FormControl('Current or Past');
  keywordInputControl: FormControl = new FormControl('');
  distanceControl: FormControl = new FormControl(100, [Validators.pattern("^[0-9]*$"), Validators.min(0), Validators.max(500)]);
  distanceUnitControl: FormControl = new FormControl('kilometers');
  fullNameControl: FormControl = new FormControl('');


  // ─── Selected lists ────────────────────────────────────────────────────────
  jobTitleSelectedList: ChipItem[] = [];
  pastJobTitleSelectedList: ChipItem[] = [];
  skillsSelectedList: ChipItem[] = [];
  booleanQuery: string = '';
  companySelectedList: ChipItem[] = [];
  industrySelectedList: ChipItem[] = [];
  functionSelectedList: ChipItem[] = [];
  locationSelectedList: ChipItem[] = [];
  educationSelectedList: ChipItem[] = [];
  schoolSelectedList: ChipItem[] = [];
  fieldOfStudySelectedList: ChipItem[] = [];
  senioritySelectedList: ChipItem[] = [];
  companysizeSelectedlist: ChipItem[] = [];
  highlightsSelectedList: any[] = [];
  positionhierarchyList: any[] = [];
  schoolLocationSelectedList: ChipItem[] = [];
  fullNameSelectedList: ChipItem[] = [];

  // ─── Per-field AI suggestions (from 2nd API) ───────────────────────────────
  // Keyed by field name, e.g. { jobtitle: [...], skills: [...], company: [...] }
  fieldSuggestions: any[] = [];

  // ─── Internal: cached payload from API #1 ─────────────────────────────────
  // null  → never fetched yet (or selections cleared)
  // value → last successful response; reuse until invalidated
  private cachedSuggestionPayload: SuggestionPayload | null = null;

  // Set to true whenever a selection changes; cleared after API #1 completes
  private suggestionPayloadStale = false;

  // Prevents concurrent API #1 calls
  private isFetchingPayload = false;

  // ─── Subjects / subscriptions ──────────────────────────────────────────────
  private typeAheadSubject = new Subject<{ event: Event; type: string }>();
  private subscriptions: Subscription[] = [];
  private typeaheadSubscription: Subscription | null = null;
  companySizeOption: any = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"];
  highLightOptions: { id: number, value: string, label: string, color: string, imageName: string }[] = [];
  positionHierarchyData: any[] = GlobalService.positionHierarchyData;
  positionhierarchyControl: FormControl = new FormControl('');
  /**Range of graduation year filter */
  graduationYearRange = {
    min: new Date().getFullYear() - 10,
    max: new Date().getFullYear() + 5
  }
  recommendCount: number;
  recommendSubscription: Subscription;
  @Input() type: string;
  filterData: any = {};
  location_type: string = '';
  isEditing: boolean = false;
  showFullNameLoader: boolean = false;
  fullNameList: any[] = [];
  locationContinents: any[] = [];
  continentstobeincluded: any[] = [];
  searchType: string = '';
  exclude_persons: any[] = [];
  private lastAppliedFilterHash: string = '';
  profiles: any[] = [];
  fullnameElasticIds: string[] = [];
  fullNameData: any[] = [];
  isFullNameLinkedinUrl: boolean = false;
  currentURL: string = '';
  defaultContinents: string;
  hasEuAccess: any;
  @Input() calledFrom: string = '';
  @Input() projectFilterData: any;
  @ViewChild('refreshCandidateResult') refreshCandidateResult: TemplateRef<any>;
  @Output() filterApplyEvent :EventEmitter<any> = new EventEmitter();
recCandLoader: Boolean = false;
showProjectFilterApplyLoader: boolean = false;
showbuttonDisable: boolean = false;

  /**Get all filter name */
  filterNames = FilterConstant.FILTER_NAMES;
  @Input() nlSearchType: string;
redirectSource: string | null = null;
  /** becomes true once the user adds/removes/changes a filter after coming from talent-insights / company-insights */
  private filtersModified = false;


  constructor(
    private sanitizer: DomSanitizer,
    private modelService: NgbModal,
    private personSearchService: PersonSearchService,
    private openaiService: OpenaiService,
    private requestService: RequestServiceService,
    private filterStoreService: FilterStoreService,
    private aggregateRequestStoreService: AggregateRequestStoreService,
    private activeModal: NgbActiveModal,
    private router: Router,
    private localStorageService: LocalStorageService,
    private route: ActivatedRoute,
    private filtermapperService: FilterResponseMapperServiceService,
    private modalService: NgbModal,
    private aiSourcingServices: AiSourcingService,
    private projectAggregateService: ProjectAggregateService,
    private aggregateService: AggregateService,
    private projectAggregateStoreService: ProjectAggregateStoreService,
    private projectFilterStoreService: ProjectFilterStoreService,
    private eventService: EventService,
    private uploadCandidateService: UploadCandidateService
  ) { }

  ngOnInit(): void {

    this.projectnumber = window.location.pathname.split('/')[2];
        this.highlightOptionsCall();
    // this.aggregateRequestStoreService.initHireRequest(); // one clean line
    this.defaultContinents = this.localStorageService.getItem('defaultContinent');
    this.hasEuAccess = this.localStorageService.getItem('hasEUPersonSearchAccess');
    this.redirectSource = this.route.snapshot.queryParams['redirectSource'] || null;

    this.filterGroups = this.filterGroups.map((item) => ({
      ...item,
      icon: this.sanitizer.bypassSecurityTrustHtml(item.icon),
    }));

    const typeaheadSub = this.typeAheadSubject
      .pipe(debounceTime(500))
      .subscribe(({ event, type }) => this.callTypeAheadSearch(event, type));

    this.subscriptions.push(typeaheadSub);
    if(this.nlSearchType == 'nlSearch') {
      const booleanquery = this.filterStoreService.getFilters()?.booleanquery;
      this.keywordInputControl.setValue(booleanquery);
      this.booleanQuery = this.keywordInputControl.value;
    }
    // getCount() is only ever called once below (either via showExistingFilters()
    // for the edit flow, or directly otherwise) - it used to also fire unconditionally
    // above for the nlSearch case, doubling the /personsearch/count POST whenever a
    // filter panel was opened in edit mode from an NL search.
    if (this.type == 'edit') {
      this.showExistingFilters();
    } else
      this.getCount();
    this.searchType = this.route.snapshot.queryParams['type'];
    this.currentURL = this.router.url;


  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.typeaheadSubscription?.unsubscribe();
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
  //this.filterStoreService.clearAll();
  }

  dismiss() {
    this.modelService.dismissAll();
  }

  // ─── Experience range validity (mirrors the *ngIf error conditions in the template) ───
  private isEmptyValue(v: any): boolean {
    return v === null || v === undefined || v === '';
  }

  isExperienceRangeInvalid(fromCtrl: FormControl, toCtrl: FormControl): boolean {
    const fromVal = fromCtrl.value;
    const toVal = toCtrl.value;

    if (!this.isEmptyValue(fromVal)) {
      const fromNum = Number(fromVal);
      if (isNaN(fromNum) || !Number.isInteger(fromNum) || fromNum < 0 || fromNum > 40) {
        return true;
      }
    }

    if (!this.isEmptyValue(toVal)) {
      const toNum = Number(toVal);
      if (isNaN(toNum) || !Number.isInteger(toNum) || toNum < 0 || toNum > 40) {
        return true;
      }
    }

    if (!this.isEmptyValue(fromVal) && !this.isEmptyValue(toVal)) {
      const fromNum = Number(fromVal);
      const toNum = Number(toVal);
      if (fromNum > toNum) {
        return true;
      }
    }

    return false;
  }

  isExperienceFilterInvalid(): boolean {
    return (
      this.isExperienceRangeInvalid(this.fromYearsControl, this.toYearsControl) ||
      this.isExperienceRangeInvalid(this.currentFromYearsControl, this.currentToYearsControl)
    );
  }
  /**
   * Method to get the accesible filter
   * @param filter
   * @returns boolean indicating whether the filter should be shown
   */
  shouldShowFilter(filter: string) {
    return this.projectFilterStoreService.shouldShowFilter(filter);
  }

  // ─── Typeahead input handler ───────────────────────────────────────────────
  searchSuggestions(event: any, type: string) {
    this.typeAheadSubject.next({ event, type });
  }
  updateWidth(el?: HTMLSelectElement, value?: any) {

    const text = el.options[el.selectedIndex].text;

    const temp = document.createElement('span');
    temp.style.visibility = 'hidden';
    temp.style.whiteSpace = 'nowrap';
    temp.style.font = getComputedStyle(el).font;
    temp.innerText = text;

    document.body.appendChild(temp);

    el.style.width = temp.offsetWidth + 25 + 'px'; // extra space for caret

    document.body.removeChild(temp);

  }
  callTypeAheadSearch(event: any, type: string) {
    const query = event.target.value;
    switch (type) {
      case 'jobtitle': {
        this.showJobTitleLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'jobtitle')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.jobTitleList = response.data;
              this.showJobTitleLoader = false;
            }
          });
        break;
      } case 'pastjobtitle': {
        this.showJobTitleLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'pastjobtitle')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.pastjobTitleList = response.data;
              this.showJobTitleLoader = false;
            }
          });
        break;
      } case 'company': {
        this.showCompanyLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'company')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.companyList = response.data;
              this.showCompanyLoader = false;
            }
          });
        break;
      } case 'industry': {
        this.showIndustryLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'industry')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.industryList = response.data;
              this.showIndustryLoader = false;
            }
          });
        break;
      } case 'skills': {
        this.showSkillsLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'skills')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.skillsList = response.data;
              this.showSkillsLoader = false;
            }
          });
        break;
      } case 'function': {
        this.showFunctionLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'function')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.functionList = response.data;
              this.showFunctionLoader = false;
            }
          });
        break;
      } case 'location': {
        this.showLocationLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'location')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.locationList = response.data;
              this.showLocationLoader = false;
            }
          });
        break;
      } case 'education': {
        this.showEducationLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'education')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.educationList = response.data;
              this.showEducationLoader = false;
            }
          });
        break;
      } case 'school': {
        this.showSchoolLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'school')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.schoolList = response.data;
              this.showSchoolLoader = false;
            }
          });
        break;
      } case 'fieldofstudy': {
        this.showFieldOfStudyLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'fieldofstudy')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.fieldOfStudyList = response.data;
              this.showFieldOfStudyLoader = false;
            }
          });
        break;
      } case 'fromYears': {
        const fromYears = this.fromYearsControl.value;
        if (!isNaN(fromYears) && Number.isInteger(fromYears)) {
          if (!isNaN(this.toYearsControl.value) && fromYears > this.toYearsControl.value) {
            console.error("fromYears should be less than toYears");
            this.fromYearsControl.setErrors({ 'invalidYears': true });
            break;
          }
          this.fromYearsControl.setErrors(null);
        }
        this.onUserFilterChange();
        break;
      } case 'toYears': {
        const toYears = this.toYearsControl.value
        if (!isNaN(toYears) && Number.isInteger(toYears)) {
          if (!isNaN(this.fromYearsControl.value) && toYears <= this.fromYearsControl.value) {
            console.error("toYears should be greater than fromYears");
            this.toYearsControl.setErrors({ 'invalidYears': true });
            break;
          }
          this.toYearsControl.setErrors(null);
        }
        this.onUserFilterChange();
        break;
      } case 'fromCurrentYears': {
        const fromYears = this.currentFromYearsControl.value
        if (!isNaN(fromYears) && Number.isInteger(fromYears)) {
          if (!isNaN(this.currentToYearsControl.value) && fromYears > this.currentToYearsControl.value) {
            console.error("currentFromYears should be less than currentToYears");
            this.currentFromYearsControl.setErrors({ 'invalidYears': true });
            break;
          }
          this.currentFromYearsControl.setErrors(null);
        } else {
          if (event.target.value == '') {
            this.currentFromYearsControl.setErrors(null);
            this.currentFromYearsControl.setValue(null);
          } else {
            //this.toExperienceNotNumberError = true
            this.currentFromYearsControl.setErrors({ 'invalidYears': true });
          }
        }
        this.onUserFilterChange();
        break;
      } case 'toCurrentYears': {
        const toYears = this.currentToYearsControl.value
        if (!isNaN(toYears) && Number.isInteger(toYears)) {
          if (!isNaN(this.currentFromYearsControl.value) && toYears <= this.currentFromYearsControl.value) {
            console.error("currentToYears should be greater than currentFromYears");
            this.currentToYearsControl.setErrors({ 'invalidYears': true });
            break;
          }
          this.currentToYearsControl.setErrors(null);
        } else {
          if (event.target.value == '') {
            this.currentToYearsControl.setErrors(null);
            this.currentToYearsControl.setValue(null);
          } else {
            //this.toExperienceNotNumberError = true
            this.currentToYearsControl.setErrors({ 'invalidYears': true });
          }
        }
        this.onUserFilterChange();
        break;
      } case 'school_location': {
        this.showSchoolLocationLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'school_location')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.schoolLocationList = response.data;
              this.showSchoolLocationLoader = false;
            }
          });
        break;
      } case 'fromgraduationyear': {
        const fromgraduationyear = this.fromgraduationyearControl.value;
        this.onUserFilterChange();
        break;
      } case 'tograduationyear': {
        const tograduationyear = this.tograduationyearControl.value;
        this.onUserFilterChange();
        break;
      } case 'distance': {
        this.distanceControl.setValue(event.target.value);
        this.filterStoreService.setFilter({ 'distancefromselectedlocations': event.target.value });
        this.onUserFilterChange();
        break;
      } case 'distanceunit': {
        this.distanceUnitControl.setValue(event.target.value);
        this.filterStoreService.setFilter({ 'distancefromselectedlocationsmeasurementunit': event.target.value });
        this.onUserFilterChange();
        break;
      } case 'gender': {
        this.genderFormControl.setValue(event.target.value);
        this.onUserFilterChange();
        break;
      } case 'fullname': {
        this.showFullNameLoader = true;
        this.typeaheadSubscription?.unsubscribe();
        if (query.includes('linkedin.com') && this.calledFrom != 'Project-candidate-list') {
          this.isFullNameLinkedinUrl = true;
        } else {
          this.isFullNameLinkedinUrl = false;
        }
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'personsuggestion')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.profiles = response.data;
              this.fullNameList = response.data;
              this.showFullNameLoader = false;
            }
          });
        break;
      }
    }
  }

  // ─── Selection handlers ────────────────────────────────────────────────────

  selectedItem(event: any, type: string, keyboardEvent?: string) {
    const value = keyboardEvent == 'enterSuggestions' ? event: (keyboardEvent == 'enter') ? event.target.value : keyboardEvent == 'aisuggestion' ? event : event.option.value;
    if (!value) return;
    const chipItem: ChipItem = {
      key: (keyboardEvent == 'enter') ? value + ".searchastext" : keyboardEvent == 'aisuggestion' ? value.key + ".aisearch" :  keyboardEvent == 'enterSuggestions' ? value.key + ".searchastext": value.key,
      chipkey: (keyboardEvent == 'enter') ? value : keyboardEvent == 'enterSuggestions' ?  value.key: value.key,
      isExcluded: false,
      isSuggested: keyboardEvent == 'aisuggestion' ? true : false,
    };

    if (type === 'jobtitle') {
      const alreadyAdded = this.jobTitleSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.jobTitleSelectedList = [...this.jobTitleSelectedList, chipItem];
      }
      this.jobTitleControl.setValue('');
      this.jobTitleList = [];
    }

    if (type === 'pastjobtitle') {
      const alreadyAdded = this.pastJobTitleSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.pastJobTitleSelectedList = [...this.pastJobTitleSelectedList, chipItem];
      }
      this.pastJobTitleControl.setValue('');
      this.pastjobTitleList = [];
    }
    if (type === 'company') {
      const alreadyAdded = this.companySelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.companySelectedList = [...this.companySelectedList, chipItem];
      }
      this.companyControl.setValue('');
      this.companyList = [];

    }
    if (type === 'industry') {
      const alreadyAdded = this.industrySelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.industrySelectedList = [...this.industrySelectedList, chipItem];
      }
      this.industryControl.setValue('');
      this.industryList = [];

    }
    if (type === 'skills') {
      const alreadyAdded = this.skillsSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.skillsSelectedList = [...this.skillsSelectedList, chipItem];
      }
      this.skillsControl.setValue('');
      this.skillsList = [];

    }

    if (type === 'function') {
      const alreadyAdded = this.functionSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.functionSelectedList = [...this.functionSelectedList, chipItem];
      }
      this.functionControl.setValue('');
      this.functionList = [];
    }

    if (type === 'location') {
      const hasEuAccess = this.localStorageService.getItem('hasEUPersonSearchAccess');
      if (hasEuAccess && this.filtermapperService.isHireSearchListing && value?.continent == 'europe') {
        const euData = this.localStorageService.getItem('euConscent');
        const now = new Date().getTime();
        if (euData) {
          const parsedData = JSON.parse(euData);
          if (!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
            const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal button-place', centered: true, backdrop: 'static', keyboard: false });
            modalRef.result.then((res) => {
              if (res.action == "success") {
                const alreadyAdded = this.locationSelectedList.some((c) => c.key === chipItem.key);
                if (!alreadyAdded) {
                  this.locationSelectedList = [...this.locationSelectedList, { ...chipItem, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, location_type: value?.location_type }];
                }


                this.locationContinents.push({ key: chipItem.key, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, type: value?.location_type });
                const locationType = _.pluck(this.locationSelectedList, 'location_type');
                this.location_type = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
                this.locationControl.setValue('');
                this.locationList = [];
                this.continentstobeincluded = _.pluck(this.locationContinents, 'continent');
                this.onUserFilterChange();
              } else {
                this.locationControl.setValue('');
              }
            })
          } else {
            const alreadyAdded = this.locationSelectedList.some((c) => c.key === chipItem.key);
            if (!alreadyAdded) {
              this.locationSelectedList = [...this.locationSelectedList, { ...chipItem, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, location_type: value?.location_type }];
            }


            this.locationContinents.push({ key: chipItem.key, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, type: value?.location_type });
            const locationType = _.pluck(this.locationSelectedList, 'location_type');
            this.location_type = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
            this.locationControl.setValue('');
            this.locationList = [];
            this.continentstobeincluded = _.pluck(this.locationContinents, 'continent');
          }
        } else {
          const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
          modalRef.result.then((res) => {
            if (res.action == "success") {
              const alreadyAdded = this.locationSelectedList.some((c) => c.key === chipItem.key);
              if (!alreadyAdded) {
                this.locationSelectedList = [...this.locationSelectedList, { ...chipItem, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, location_type: value?.location_type }];
              }


              this.locationContinents.push({ key: chipItem.key, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, type: value?.location_type });
              const locationType = _.pluck(this.locationSelectedList, 'location_type');
              this.location_type = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
              this.locationControl.setValue('');
              this.locationList = [];
              this.continentstobeincluded = _.pluck(this.locationContinents, 'continent');
              this.onUserFilterChange();
            } else {
              this.locationControl.setValue('');
            }
          })
        }
      } else {
        const alreadyAdded = this.locationSelectedList.some((c) => c.key === chipItem.key);
        if (!alreadyAdded) {
          this.locationSelectedList = [...this.locationSelectedList, { ...chipItem, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, location_type: value?.location_type }];
        }


        this.locationContinents.push({ key: chipItem.key, continent: keyboardEvent == 'enterSuggestions' ? value?.location_continent[0]?.key : value?.continent, type: value?.location_type });
        const locationType = _.pluck(this.locationSelectedList, 'location_type');
        this.location_type = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
        this.locationControl.setValue('');
        this.locationList = [];
        this.continentstobeincluded = _.pluck(this.locationContinents, 'continent');

      }
    }
    if (type === 'education') {
      const alreadyAdded = this.educationSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.educationSelectedList = [...this.educationSelectedList, chipItem];
      }
      this.educationControl.setValue('');
      this.educationList = [];
    }
    if (type === 'school') {
      const alreadyAdded = this.schoolSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.schoolSelectedList = [...this.schoolSelectedList, chipItem];
      }
      this.schoolControl.setValue('');
      this.schoolList = [];
    }
    if (type === 'fieldofstudy') {
      const alreadyAdded = this.fieldOfStudySelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.fieldOfStudySelectedList = [...this.fieldOfStudySelectedList, chipItem];
      }
      this.fieldOfStudyControl.setValue('');
      this.fieldOfStudyList = [];
    } if (type == 'gender') {
      const gender = this.genderFormControl.value;
    } if (type == 'school_location') {
      const alreadyAdded = this.schoolLocationSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.schoolLocationSelectedList = [...this.schoolLocationSelectedList, chipItem];
      }
      this.educationLocationControl.setValue('');
      this.schoolLocationList = [];
    } if (type == 'booleansearch') {
      this.booleanQuery = this.keywordInputControl.value;
      this.isEditing = false;
    } if (type == 'fullname') {
      const alreadyAdded = this.fullNameSelectedList.some((c) => c.key === chipItem.key);
      if (!alreadyAdded) {
        this.fullNameSelectedList = [...this.fullNameSelectedList, chipItem];
      }
      this.fullNameControl.setValue('');
      this.fullNameList = [];
    }
    this.onUserFilterChange();


    if (!this.cachedSuggestionPayload && (type === 'jobtitle' || type === 'pastjobtitle' || type === 'skills' || type === 'booleansearch')) {
      this.invalidateAndRefetch(type);
    } else {
      this.fetchFieldSuggestions(type);
    }

  }

  /** Call this whenever boolean query textarea changes (debounced from template) */
  onBooleanChange(value: string) {
    this.booleanQuery = value;
    this.invalidateAndRefetch('boolean');
  }

  removeChip(chip: ChipItem, type: string) {
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'pastjobtitle':
        this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'company':
        this.companySelectedList = this.companySelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'industry':
        this.industrySelectedList = this.industrySelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'function':
        this.functionSelectedList = this.functionSelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'location':
        this.locationSelectedList = this.locationSelectedList.filter((c) => c.key !== chip.key);
        this.locationContinents = this.locationContinents.filter((c) => c.key !== chip.key);
        this.continentstobeincluded = _.pluck(this.locationContinents, 'continent');
        break;
      case 'education':
        this.educationSelectedList = this.educationSelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'school':
        this.schoolSelectedList = this.schoolSelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'fieldofstudy':
        this.fieldOfStudySelectedList = this.fieldOfStudySelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'school_location':
        this.schoolLocationSelectedList = this.schoolLocationSelectedList.filter((c) => c.key !== chip.key);
        break;
      case 'seniority':
        this.senioritySelectedList = this.senioritySelectedList.filter((c) => c.key !== chip.key);
        const seniority = _.pluck(this.senioritySelectedList, 'key');
        this.seniorityControl.setValue(seniority);
        break;
      case 'companysize':
        this.companysizeSelectedlist = this.companysizeSelectedlist.filter((c) => c.key !== chip.key);
        const companysize = _.pluck(this.companysizeSelectedlist, 'key');
        this.companysizeControl.setValue(companysize);
        break;
      case 'highlights':
        this.highlightsSelectedList = this.highlightsSelectedList.filter((c) => c.key !== chip.key);
        const highlights = _.pluck(this.highlightsSelectedList, 'key');
        this.highlightSelectedControl.setValue(highlights);
        break;
      case 'positionhierarchy':
        this.positionhierarchyList = this.positionhierarchyList.filter((c) => c.key !== chip.key);
        const positionhierarchy = _.pluck(this.positionhierarchyList, 'key');
        this.positionhierarchyControl.setValue(positionhierarchy);
        break;
      case 'fullname':
        this.fullNameSelectedList = this.fullNameSelectedList.filter((c) => c.key !== chip.key);
        if (this.fullNameData?.length > 0) {
          this.fullNameData = this.fullNameData.filter((c) => c.full_name.toLowerCase().trim() !== chip.key.toLowerCase().trim());
          this.fullnameElasticIds = this.fullNameData.map((c) => c.id);
        }
        break;
    }
    if (this.jobTitleSelectedList?.length == 0 && this.pastJobTitleSelectedList?.length == 0 && this.skillsSelectedList?.length == 0) {
      this.cachedSuggestionPayload = null;


    }
    if (this.jobTitleSelectedList?.length > 0 || this.pastJobTitleSelectedList?.length > 0 || this.skillsSelectedList?.length > 0) {
      this.invalidateAndRefetch(type);
    } else {
      this.fetchFieldSuggestions(type);
    }
    this.onUserFilterChange();

  }

  excludeChip(chip: ChipItem, type: string) {
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.map((c) =>
          c.key === chip.key ? { ...c, isExcluded: !c.isExcluded } : c
        );
        break;
      case 'pastjobtitle':
        this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.map((c) =>
          c.key === chip.key ? { ...c, isExcluded: !c.isExcluded } : c
        );
        break;
      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.map((c) =>
          c.key === chip.key ? { ...c, isExcluded: !c.isExcluded } : c
        );
        break;
      case 'company':
        this.companySelectedList = this.companySelectedList.map((c) =>
          c.key === chip.key ? { ...c, isExcluded: !c.isExcluded } : c
        );
        break;
      case 'industry':
        this.industrySelectedList = this.industrySelectedList.map((c) =>
          c.key === chip.key ? { ...c, isExcluded: !c.isExcluded } : c
        );
        break;
      case 'function':
        this.functionSelectedList = this.functionSelectedList.map((c) =>
          c.key === chip.key ? { ...c, isExcluded: !c.isExcluded } : c
        );
        break;
      case 'location':
        this.locationSelectedList = this.locationSelectedList.map((c) =>
          c.key === chip.key ? { ...c, isExcluded: !c.isExcluded } : c
        );
        break;
    }
    this.onUserFilterChange();
    !this.cachedSuggestionPayload && this.invalidateAndRefetch(type);
  }

  addToSelectedList(item: any, type: string) {
    this.selectedItem({ option: { value: item } }, type);
  }

  // ─── Core: invalidate cache → call API #1 → call API #2 ──────────────────

  /**
   * Marks the cached suggestion payload as stale.
   * Triggers API #1 (getJobTitleAndSkillSuggestions), and on success
   * calls API #2 (getFieldSuggestions) for the field that just changed.
   *
   * API #2 is ONLY called here — never on input click/focus.
   */
  private invalidateAndRefetch(changedField: string) {
    this.suggestionPayloadStale = true;

    if (this.isFetchingPayload) return;

    this.isFetchingPayload = true;
    const payload = this.buildSuggestionRequestPayload();

    this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe({
      next: (response: any) => {
        this.isFetchingPayload = false;
        if (response.status === 'success' && response.data) {
          // Cache the result from API #1
          this.cachedSuggestionPayload = response.data;
          this.suggestionPayloadStale = false;

          // Now call API #2 for the specific field that triggered this
          this.fetchFieldSuggestions(changedField);
        }
      },
      error: () => {
        this.isFetchingPayload = false;
      },
    });
  }

  /**
   * Calls the per-field suggestion API (#2).
   * Uses the cached payload from API #1.
   * Only called from invalidateAndRefetch — never from input events.
   *
   * @param field The filter field to get suggestions for (e.g. 'jobtitle', 'skills')
   */
  private fetchFieldSuggestions(field: string) {
    if (this.calledFrom == 'Project-candidate-list') {
      const payload = this.projectAggregateService.getProjectAggregateServices();
      if (this.cachedSuggestionPayload) {
        payload.jobtitles = this.cachedSuggestionPayload.suggestedjobtitles;
        payload.preferredskills = this.cachedSuggestionPayload.suggestedskills;
      }

      payload.seniority = this.senioritySelectedList?.length ? this.senioritySelectedList.map(item => item.key) : [],
        payload.minexperience = this.fromYearsControl?.value ? this.fromYearsControl?.value : null,
        payload.maxexperience = this.toYearsControl?.value ? this.toYearsControl?.value : null,
        payload.excluded_jobtitles = this.jobTitleSelectedList?.length ? this.jobTitleSelectedList.filter(x => x.isExcluded).map(item => item.key) : [],
        payload.mandatoryskills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isMandatory && !x?.isExcluded).map(item => item?.key) : [],
        payload.excluded_preferredskills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isExcluded && !x?.isMandatory).map(item => item?.key) : [],
        payload.excluded_mandatoryskills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isExcluded && x?.isMandatory).map(item => item?.key) : [],
        payload.functions = this.functionSelectedList?.length ? this.functionSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [],
        payload.excluded_functions = this.functionSelectedList?.length ? this.functionSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.locations = this.locationSelectedList?.length ? this.locationSelectedList.filter(x => !x?.isExcluded).map(item => item.key) : [],
        payload.excluded_locations = this.locationSelectedList?.length ? this.locationSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.companies = this.companySelectedList?.length ? this.companySelectedList.filter(x => !x?.isExcluded).map(item => item?.key) : [],
        payload.excluded_companies = this.companySelectedList?.length ? this.companySelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.industries = this.industrySelectedList?.length ? this.industrySelectedList.filter(x => !x.isExcluded).map(item => item.key) : [],
        payload.excluded_industries = this.industrySelectedList?.length ? this.industrySelectedList.filter(x => x.isExcluded).map(item => item.key) : [],
        payload.pastjobtitles = this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [],
        payload.excluded_pastjobtitles = this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(x => x.isExcluded).map(item => item.key) : [],
        payload.schools = this.schoolSelectedList?.length ? this.schoolSelectedList.map(item => item.key) : [],
        payload.educationaldegrees = this.educationSelectedList?.length ? this.educationSelectedList.map(item => item.key) : [],
        payload.educationalmajors = this.fieldOfStudySelectedList?.length ? this.fieldOfStudySelectedList.map(item => item.key) : [],
        payload.companysizes = this.companysizeSelectedlist?.length ? this.companysizeSelectedlist.map(item => item.key) : [],
        payload.distancefromselectedlocations = this.distanceControl.value ? this.distanceControl?.value : '100',
        payload.distancefromselectedlocationsmeasurementunit = this.distanceUnitControl?.value ? this.distanceUnitControl.value : 'Kilometers',

        payload.profilehighlights = this.highlightsSelectedList?.length ? this.highlightsSelectedList.map(item => item.value) : [],
        payload.positionhierarchies = this.positionhierarchyList?.length ? this.positionhierarchyList.map(item => item.key) : [],
        payload.current_minexperience = this.currentFromYearsControl?.value ? Number(this.currentFromYearsControl?.value) : null,
        payload.current_maxexperience = this.currentToYearsControl?.value ? Number(this.currentToYearsControl?.value) : null,

        payload.schoollocation = this.schoolLocationSelectedList?.length ? this.schoolLocationSelectedList.map(item => item.key) : [],
        payload.genders = this.genderFormControl.value && this.genderFormControl.value != 'All' ? [this.genderFormControl.value] : ['All'],
        payload.companytype = this.companyStatus.value == 'Current or Past' ? 'All' : this.companyStatus.value || 'Current',
        payload.jobtitletype = this.jobStatus.value == 'Current or Past' ? 'All' : this.jobStatus.value || 'Current',
        payload.industrytype = this.industryStatus.value == 'Current or Past' ? 'All' : this.industryStatus.value || 'Current',
        payload.experiencetype = this.experienceStatus.value || 'Current',
        payload.booleanquery = this.booleanQuery || "*",
        payload.fromgraduationyear = this.fromgraduationyearControl?.value ? this.fromgraduationyearControl?.value : [],
        payload.tograduationyear = this.tograduationyearControl?.value ? this.tograduationyearControl?.value : [],
        payload.include_persons = this.fullnameElasticIds ? this.fullnameElasticIds : [],
        payload.fullnames = this.fullNameSelectedList?.length ? this.fullNameSelectedList.map(item => item.key) : [];
      payload.continentstobeincluded = this.continentstobeincluded?.length && this.continentstobeincluded[0] != null ? this.continentstobeincluded : [this.localStorageService.getItem('defaultContinent')];
      if (field == 'location') {
        payload.aggregatetype = 'location_name-location_continent';
      } else {
        payload.aggregatetype = field;

      }
      this.aggregateService.getProjectTotalAggs(payload).subscribe({
        next: (response: any) => {
          if (response.status === 'success' && response.data) {
            // Store suggestions per field so the template can show them
            this.fieldSuggestions[field] = field == 'location' ? response.data.aggregations['location_name-location_continent'] : response.data.aggregations[field];
            this.getFieldSuggestions(field);

          }
        },
        error: (err) => {
          console.error(`Field suggestion error for "${field}":`, err);
        },


      })
    } else {
      const payload = this.requestService.getHireRequestWithFilters();
      if (this.cachedSuggestionPayload) {
        payload.jobtitles = this.cachedSuggestionPayload.suggestedjobtitles;
        payload.preferredskills = this.cachedSuggestionPayload.suggestedskills;
      }
      payload.pastjobtitles = this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [];
      payload.exclude_pastjobtitles = this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(x => x.isExcluded).map(item => item.key) : []
      payload.mandatoryskills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isMandatory && !x?.isExcluded).map(item => item?.key) : []
      payload.companies = this.companySelectedList?.length ? this.companySelectedList.filter(x => !x?.isExcluded).map(item => item?.key) : []
      payload.industries = this.industrySelectedList?.length ? this.industrySelectedList.filter(x => !x?.isExcluded).map(item => item?.key) : []
      payload.genders = this.genderFormControl.value && this.genderFormControl.value != 'All' ? [this.genderFormControl.value] : ['All'],
        payload.seniority = this.senioritySelectedList?.length ? this.senioritySelectedList.map(item => item.key) : [],
        payload.schools = this.schoolSelectedList?.length ? this.schoolSelectedList.map(item => item.key) : [],
        payload.educationaldegrees = this.educationSelectedList?.length ? this.educationSelectedList.map(item => item.key) : []
      payload.educationalmajors = this.fieldOfStudySelectedList?.length ? this.fieldOfStudySelectedList.map(item => item.key) : [],

        payload.companytype = this.companyStatus.value == 'Current or Past' ? 'All' : this.companyStatus.value || 'Current',
        payload.jobtitletype = this.jobStatus.value == 'Current or Past' ? 'All' : this.jobStatus.value || 'Current',
        payload.industrytype = this.industryStatus.value == 'Current or Past' ? 'All' : this.industryStatus.value || 'Current',
        payload.experiencetype = this.experienceStatus.value || 'Total',
        payload.fromyearsofexperience = this.fromYearsControl?.value ? [this.fromYearsControl?.value] : [],
        payload.toyearsofexperience = this.toYearsControl?.value ? [this.toYearsControl?.value] : [],
        payload.locations = this.locationSelectedList?.length ? this.locationSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [this.localStorageService.getItem('defaultContinent')],
        payload.continentstobeincluded = this.continentstobeincluded?.length && this.continentstobeincluded[0] != null ? this.continentstobeincluded : [this.localStorageService.getItem('defaultContinent')],
        payload.functions = this.functionSelectedList?.length ? this.functionSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [],
        payload.fullnames = this.fullNameSelectedList?.length ? this.fullNameSelectedList.map(item => item.key) : [],
        payload.currentfromyearsofexperience = this.currentFromYearsControl?.value ? [this.currentFromYearsControl?.value] : [],
        payload.currenttoyearsofexperience = this.currentToYearsControl?.value ? [this.currentToYearsControl?.value] : [],

        payload.schoollocation = this.schoolLocationSelectedList?.length ? this.schoolLocationSelectedList.map(item => item.key) : [],
        payload.exclude_schoollocation = [],
        payload.needcuratedtalentpooltags = true,
        payload.distancefromselectedlocations = 100,
        payload.distancefromselectedlocationsmeasurementunit = 'kilometers',

        payload.profilehighlights = this.highlightsSelectedList?.length ? this.highlightsSelectedList.map(item => item.value) : [],
        payload.positionhierarchies = this.positionhierarchyList?.length ? this.positionhierarchyList.map(item => item.key) : [],
        payload.exclude_jobtitles = this.jobTitleSelectedList?.length ? this.jobTitleSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.exclude_companies = this.companySelectedList?.length ? this.companySelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.exclude_industries = this.industrySelectedList?.length ? this.industrySelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.exclude_functions = this.functionSelectedList?.length ? this.functionSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.exclude_locations = this.locationSelectedList?.length ? this.locationSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
        payload.exclude_preferredskills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isExcluded && !x?.isMandatory).map(item => item?.key) : [],
        payload.exclude_mandatoryskills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isExcluded && x?.isMandatory).map(item => item?.key) : [],
        payload.fromgraduationyear = this.fromgraduationyearControl?.value ? this.fromgraduationyearControl?.value : [],
        payload.tograduationyear = this.tograduationyearControl?.value ? this.tograduationyearControl?.value : [],
        payload.exclude_persons = this.exclude_persons,
        payload.include_persons = this.fullnameElasticIds ? this.fullnameElasticIds : [],
        payload.companysizes = this.companysizeSelectedlist?.length ? this.companysizeSelectedlist.map(item => item.key) : []
      if (field == 'location') {
        payload.aggregatetype = 'location_name-location_continent';
      } else {
        payload.aggregatetype = field;

      }
      this.personSearchService.getTotalAggs(payload).subscribe({
        next: (response: any) => {
          if (response.status === 'success' && response.data) {
            // Store suggestions per field so the template can show them
            this.fieldSuggestions[field] = field == 'location' ? response.data.aggregations['location_name-location_continent'] : response.data.aggregations[field];
            this.getFieldSuggestions(field);

          }
        },
        error: (err) => {
          console.error(`Field suggestion error for "${field}":`, err);
        },
      });
    }


  }

  /**
   * Reads current selected lists and builds the payload for API #1.
   */
  private buildSuggestionRequestPayload() {
    const titles = this.jobTitleSelectedList
      .filter((jt) => !jt.isSuggestion)
      .map((jt) => jt.key.replace('.searchastext', ''));

    const pastTitles = this.pastJobTitleSelectedList
      .filter((jt) => !jt.isSuggestion)
      .map((jt) => jt.key.replace('.searchastext', ''));

    const skills = this.skillsSelectedList
      .filter((s) => !s.isSuggestion)
      .map((s) => s.key.replace('.searchastext', ''));

    return {
      boolean: this.booleanQuery || null,
      jobtitles: [...titles, ...pastTitles],
      skills,
    };
  }

  /**
   * Gets field suggestions based on the selected filters.
   * @param field The field to get suggestions for.
   * @returns An array of suggestions for the specified field.
   */
  getFieldSuggestions(field: string) {
    switch (field) {
      case 'jobtitle':
        const existingSuggestions = this.jobTitleSelectedList;
        const newSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newSuggestions.slice(0, 5);
        break;// limit to top 5 suggestions
      case 'pastjobtitle':
        const existingPastSuggestions = this.pastJobTitleSelectedList;
        const newPastSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingPastSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newPastSuggestions.slice(0, 5);
        break;
      case 'company':
        const existingCompanySuggestions = this.companySelectedList;
        const newCompanySuggestions = this.fieldSuggestions[field].filter(suggestion => !existingCompanySuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newCompanySuggestions.slice(0, 5);
        break;
      case 'industry':
        const existingIndustrySuggestions = this.industrySelectedList;
        const newIndustrySuggestions = this.fieldSuggestions[field].filter(suggestion => !existingIndustrySuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newIndustrySuggestions.slice(0, 5);
        break;
      case 'skills':
        const existingSkillsSuggestions = this.skillsSelectedList;
        const newSkillsSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingSkillsSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newSkillsSuggestions.slice(0, 5);
        break;
      case 'function':
        const existingFunctionSuggestions = this.functionSelectedList;
        const newFunctionSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingFunctionSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newFunctionSuggestions.slice(0, 5);
        break;
      case 'location':
        const existingLocationSuggestions = this.locationSelectedList;
        const newLocationSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingLocationSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newLocationSuggestions.slice(0, 5);
        break;
      case 'education':
        const existingEducationSuggestions = this.educationSelectedList;
        const newEducationSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingEducationSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newEducationSuggestions.slice(0, 5);
        break;
      case 'school':
        const existingSchoolSuggestions = this.schoolSelectedList;
        const newSchoolSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingSchoolSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newSchoolSuggestions.slice(0, 5);
        break;
      case 'fieldofstudy':
        const existingFieldOfStudySuggestions = this.fieldOfStudySelectedList;
        const newFieldOfStudySuggestions = this.fieldSuggestions[field].filter(suggestion => !existingFieldOfStudySuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newFieldOfStudySuggestions.slice(0, 5);
        break;
      case 'school_location':
        const existingSchoolLocationSuggestions = this.schoolLocationSelectedList;
        const newSchoolLocationSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingSchoolLocationSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newSchoolLocationSuggestions.slice(0, 5);
        break;

    }

    return this.fieldSuggestions;
  }

  showAISuggestions(field: string) {
    if (!this.cachedSuggestionPayload && (field == 'jobtitle' && this.jobTitleSelectedList.length > 0) || (field == 'pastjobtitle' && this.pastJobTitleSelectedList.length > 0) || (field == 'skills' && this.skillsSelectedList.length > 0)) {
      this.invalidateAndRefetch(field);
    } else {
      this.fetchFieldSuggestions(field);
    }
  }

  senioritySelection(event) {
    this.senioritySelectedList = event.value.map(item => ({
      key: item,
      chipkey: item
    }));
    const seniority = this.senioritySelectedList.map(item => item.key);
    this.onUserFilterChange();
  }
  /**
   * filter by status for job title, experience and company
   * @param event
   * @param type
   */

  filterByStatus(event, type: string) {
    const value = (event.target as HTMLSelectElement).value; // ✅ cast to HTMLSelectElement

    const filterStatus = value;

    console.log(filterStatus, 'filterStatusfilterStatusfilterStatusfilterStatusfilterStatusfilterStatusfilterStatusfilterStatusfilterStatusfilterStatusfilterStatus')
    switch (type) {
      case 'jobtitle': {
        this.jobStatus.setValue(filterStatus);
        break;
      }
      case 'experience': {
        this.experienceStatus.setValue(filterStatus);
        break;
      }
      case 'company': {
        this.companyStatus.setValue(filterStatus);
        break;
      } case 'industry': {
        this.industryStatus.setValue(filterStatus);
        break;
      }

    }
    this.onUserFilterChange();
  }

  companySizeSelection(event) {
    this.companysizeSelectedlist = event.value.map(item => ({
      key: item,
      chipkey: item
    }));
    const companySize = this.companysizeSelectedlist.map(item => item.key);
    this.onUserFilterChange();
  }

  /**
* Used to form array of objects for highlights filters on the basis of data got from backend.
*/
highlightOptionsCall() {
  this.personSearchService.getHighlightsOptions().subscribe((res: any) => {
    this.highLightOptions = this.highlightOptionsObjectFormation(res.data);
    console.log(this.highLightOptions, 'this.highLightOptionsthis.highLightOptionsthis.highLightOptionsthis.highLightOptionsthis.highLightOptions')
    if (this.type == 'edit') {
      this.highlightsSelectedList = (this.filterData?.profilehighlights ?? [])
        .map((v: string) => this.highLightOptions.find(option => option.value === v))
        .filter((opt: any) => !!opt)
        .map((opt: any) => ({ ...opt, key: opt.label, chipkey: opt.label }));
      console.log(this.highlightsSelectedList, 'selected')
      this.highlightSelectedControl.setValue(_.pluck(this.highlightsSelectedList, 'id'));
    }
    // getCount() is NOT called here - ngOnInit() already triggers it once (directly, or via
    // showExistingFilters() for edit mode, which independently repopulates highlightsSelectedList
    // from filterData). Calling it again here raced the async getHighlightsOptions() response
    // against that synchronous call, firing /personsearch/count twice on every filter panel open.
  });
}

  /**
* Used to form array of Object for highlights filter on the basis of backend data and Map them with label, color and id;
* @param data array of values of filters
*/
  highlightOptionsObjectFormation(data: string[]) {
    const highlight = [];
    data && data.length && data.map(x => {
      if (x === 'Unicorns') {
        highlight.push(
          { id: 1, label: 'Unicorn Experience', value: `${x}`, color: 'yellow', imageName: 'unicorn' }
        )
      } else if (x === 'Techie') {
        highlight.push(
          { id: 2, label: 'Techie', value: `${x}`, color: 'green', imageName: 'techie' }
        )
      } else if (x === 'Fortune-500') {
        highlight.push(
          { id: 3, label: 'Fortune 500 Experience', value: `${x}`, color: 'fortune', imageName: 'fortune500' }
        )
      } else if (x === 'Tier-1 School') {
        highlight.push(
          { id: 4, label: 'Tier 1 School', value: `${x}`, color: 'teal', imageName: 'tier1school' }
        )
      } else if (x === 'C9 League (China)') {
        highlight.push(
          { id: 5, label: 'C9 League (China)', value: `${x}`, color: 'c9League', imageName: 'c9' }
        )
      } else if (x === 'Ivy League (USA)') {
        highlight.push(
          { id: 6, label: 'Ivy League (USA)', value: `${x}`, color: 'ivy', imageName: 'ivy' }
        )
      } else if (x === 'Group of Eight (Australia)') {
        highlight.push(
          { id: 7, label: 'Group of Eight (Australia)', value: `${x}`, color: 'groupOfEight', imageName: 'go8' }
        )
      } else if (x === 'Russell Group (UK)') {
        highlight.push(
          { id: 8, label: 'Russell Group (UK)', value: `${x}`, color: 'russellGroup', imageName: 'russell' }
        )
      } else if (x === 'MAANG') {
        highlight.push(
          { id: 9, label: 'MAANG', value: `${x}`, color: 'maang', imageName: 'maang' }
        )
      } else if (x === 'DAX 40') {
        highlight.push(
          { id: 10, label: 'DAX 40', value: `${x}`, color: 'dax', imageName: 'dax40' }
        )
      } else if (x === 'NASDAQ 100') {
        highlight.push(
          { id: 11, label: 'NASDAQ 100', value: `${x}`, color: 'nasdaq', imageName: 'nasdaq100' }
        )
      } else if (x === 'Nifty 50 / Sensex') {
        highlight.push(
          { id: 12, label: 'Nifty 50 / Sensex', value: `${x}`, color: 'nifty', imageName: 'nifty50' }
        )
      } else if (x === 'Fortune Global 500') {
        highlight.push(
          { id: 13, label: 'Fortune Global 500', value: `${x}`, color: 'fortuneGlobal', imageName: 'fortuneglobal500' }
        )
      } else if (x === 'S&P 500') {
        highlight.push(
          { id: 14, label: 'S&P 500', value: `${x}`, color: 'sp', imageName: 'sp500' }
        )
      } else if (x === 'Big Four') {
        highlight.push(
          { id: 15, label: 'Big 4', value: `${x}`, color: 'bigfour', imageName: 'big4' }
        )
      } else if (x === 'DOW 30') {
        highlight.push(
          { id: 16, label: 'DOW 30', value: `${x}`, color: 'dow', imageName: 'dow30' }
        )
      } else if (x === 'Fortune 500') {
        highlight.push(
          { id: 17, label: 'Fortune 500', value: `${x}`, color: 'fortune', imageName: 'fortune500' }
        )
      } else if (x === 'Big Oil') {
        highlight.push(
          { id: 18, label: 'Big Oil', value: `${x}`, color: 'bigoil', imageName: 'bigoil' }
        )
      } else if (x === 'FTSE 100') {
        highlight.push(
          { id: 19, label: 'FTSE 100', value: `${x}`, color: 'ftse', imageName: 'ftse100' }
        )
      } else if (x === 'U15 Group (Canada)') {
        highlight.push(
          { id: 20, label: 'U15 Group (Canada)', value: `${x}`, color: 'u15group', imageName: 'u15' }
        )
      } else if (x === 'BATX') {
        highlight.push(
          { id: 21, label: 'BATX', value: `${x}`, color: 'batx', imageName: 'batx' }
        )
      }
    })
    return highlight;
  }

  onChangeHighlights(event) {
    console.log(this.highlightSelectedControl.value, 'highlightSelectedControl.valuehighlightSelectedControl.valuehighlightSelectedControl.valuehighlightSelectedControl.valuehighlightSelectedControl.valuehighlightSelectedControl.valuehighlightSelectedControl.valuehighlightSelectedControl.valuehighlightSelectedControl.value')
    this.highlightsSelectedList = this.highLightOptions.filter(x => event.value.includes(x.id));
    this.highlightsSelectedList = this.highlightsSelectedList.map((x: any) => ({
      ...x,
      key: x.label,
      chipkey: x.label
    }));
    this.highlightSelectedControl.setValue(_.pluck(this.highlightsSelectedList, 'id'));
    this.onUserFilterChange();
  }

  changePositionHierarchy(event) {
    this.positionhierarchyList = event.value.map(item => ({
      key: item,
      chipkey: item
    }));
    const positionHierarchy = this.positionhierarchyList.map(item => item.key);
    this.onUserFilterChange();
  }

  /**
 * Used to get list of year in valid range
 * @param type type of request i.e. `to`, `from`
 * @returns
 */
  graduationYearList(type: string) {
    let start = this.graduationYearRange?.min;;
    let end = this.graduationYearRange?.max;

    if (type == 'from') {
      end = Number(this.tograduationyearControl.value) || end;
    } else if (type == 'to') {
      start = Number(this.fromgraduationyearControl.value) || start;
    }

    const output = [];
    for (let i = start; i <= end; i++) {
      output.push(i);
    }
    return output;
  }

  /** Called for every user-driven filter change: marks filters as modified (insights redirects only) and refreshes the count. */
  private onUserFilterChange() {
    if (this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') {
      this.filtersModified = true;
    }
    this.getCount();
  }

  getCount() {
    if (this.calledFrom == 'Project-candidate-list') {
      this.getCountForProjectCandidateList();
    } else {
      this.recCandLoader = true;
      let request = {};
      // insights request until the user adds/removes a filter; after that the normal request
      if(!this.filtersModified && (this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights')){
        request = this.requestService.getHireRequestWithFilters();
      } else {
   request = {

      startindex: 0,
      resultsize: 20,
      searchviaboolean: true,
      booleanquery: this.booleanQuery || "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: this.jobTitleSelectedList?.length ? this.jobTitleSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [],
      pastjobtitles: this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [],
      exclude_pastjobtitles: this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(x => x.isExcluded).map(item => item.key) : [],
      preferredskills: this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => !x?.isExcluded && !x?.isMandatory).map(item => item?.key) : [],
      mandatoryskills: this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isMandatory && !x?.isExcluded).map(item => item?.key) : [],
      companies: this.companySelectedList?.length ? this.companySelectedList.filter(x => !x?.isExcluded).map(item => item?.key) : [],
      industries: this.industrySelectedList?.length ? this.industrySelectedList.filter(x => !x?.isExcluded).map(item => item?.key) : [],
      exclusionlist: [],
      genders: this.genderFormControl.value && this.genderFormControl.value != 'All' ? [this.genderFormControl.value] : ['All'],
      seniority: this.senioritySelectedList?.length ? this.senioritySelectedList.map(item => item.key) : [],
      schools: this.schoolSelectedList?.length ? this.schoolSelectedList.map(item => item.key) : [],
      schooltypes: [],
      educationaldegrees: this.educationSelectedList?.length ? this.educationSelectedList.map(item => item.key) : [],
      educationalmajors: this.fieldOfStudySelectedList?.length ? this.fieldOfStudySelectedList.map(item => item.key) : [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,

      zipcodes: [],
      candidateshavingcontacts: false,
      companytype: this.companyStatus.value == 'Current or Past' ? 'All' : this.companyStatus.value || 'Current',
      jobtitletype: this.jobStatus.value == 'Current or Past' ? 'All' : this.jobStatus.value || 'Current',
      industrytype: this.industryStatus.value == 'Current or Past' ? 'All' : this.industryStatus.value || 'Current',
      experiencetype: this.experienceStatus.value || 'Total',
      fromyearsofexperience: this.fromYearsControl?.value ? [this.fromYearsControl?.value] : [],
      toyearsofexperience: this.toYearsControl?.value ? [this.toYearsControl?.value] : [40],
      locations: this.locationSelectedList?.length ? this.locationSelectedList.filter(x => !x.isExcluded).map(item => item.key) : (this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_UPLOAD_CANDIDATES || this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_INBOUND_APPLICATION) ? [] : [this.localStorageService.getItem('defaultContinent')],
      continentstobeincluded: this.continentstobeincluded?.length && this.continentstobeincluded[0] != null ? this.continentstobeincluded : (this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_UPLOAD_CANDIDATES || this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_INBOUND_APPLICATION) ? [] : [this.localStorageService.getItem('defaultContinent')],
      functions: this.functionSelectedList?.length ? this.functionSelectedList.filter(x => !x.isExcluded).map(item => item.key) : [],
      fullnames: this.fullNameSelectedList?.length ? this.fullNameSelectedList.map(item => item.key) : [],
      currentfromyearsofexperience: this.currentFromYearsControl?.value ? [this.currentFromYearsControl?.value] : [],
      currenttoyearsofexperience: this.currentToYearsControl?.value ? [this.currentToYearsControl?.value] : [],

      schoollocation: this.schoolLocationSelectedList?.length ? this.schoolLocationSelectedList.map(item => item.key) : [],
      exclude_schoollocation: [],
      needcuratedtalentpooltags: true,
      distancefromselectedlocations: this.distanceControl?.value ?? '100',
      distancefromselectedlocationsmeasurementunit: this.distanceUnitControl?.value ?? 'kilometers',

      profilehighlights: this.highlightsSelectedList?.length ? this.highlightsSelectedList.map(item => item.value) : [],
      positionhierarchies: this.positionhierarchyList?.length ? this.positionhierarchyList.map(item => item.key) : [],
      module: 'personsearch',
      searchedfrom: this.type == 'edit' ? this.route.snapshot.queryParams['type'] == 'nl-search' ? 'job-description' : this.route.snapshot.queryParams['type'] : 'advanced-search',
      exclude_jobtitles: this.jobTitleSelectedList?.length ? this.jobTitleSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
      exclude_companies: this.companySelectedList?.length ? this.companySelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
      exclude_industries: this.industrySelectedList?.length ? this.industrySelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
      exclude_functions: this.functionSelectedList?.length ? this.functionSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
      exclude_locations: this.locationSelectedList?.length ? this.locationSelectedList.filter(x => x?.isExcluded).map(item => item?.key) : [],
      exclude_preferredskills: this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isExcluded && !x?.isMandatory).map(item => item?.key) : [],
      exclude_mandatoryskills: this.skillsSelectedList?.length ? this.skillsSelectedList.filter(x => x?.isExcluded && x?.isMandatory).map(item => item?.key) : [],
      fromgraduationyear: this.fromgraduationyearControl?.value ? this.fromgraduationyearControl?.value : [],
      tograduationyear: this.tograduationyearControl?.value ? this.tograduationyearControl?.value : [],
      exclude_persons: this.exclude_persons,
      include_persons: this.fullnameElasticIds ? this.fullnameElasticIds : [],
      companysizes: this.companysizeSelectedlist?.length ? this.companysizeSelectedlist.map(item => item.key) : [],

    }
      }

    //   const request = this.requestService.getHireRequestWithFilters();

    console.log(this.calledFrom, 'calledFrom')

      if (this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_UPLOAD_CANDIDATES || this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_INBOUND_APPLICATION) {

        request['type'] = this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_UPLOAD_CANDIDATES ? 'upload' : 'inbound';
        this.recommendSubscription = this.uploadCandidateService.getCandidateCount(request, this.projectnumber).subscribe((response: any) => {
          if (response.status === 'success' && response.data) {
            this.recCandLoader = false;
            this.recommendCount = response.data?.candidatesCount ?? 0;
          } else {
            this.recCandLoader = false;
            this.recommendCount = 0;
          }
        }, (err) => {
          this.recCandLoader = false;
          this.recommendCount = 0;
        });

      } else {
        this.recommendSubscription = this.personSearchService.getRecommendCount(request).subscribe(response => {
          this.recCandLoader = false;
          this.recommendCount = response.data.totalresultscount;
        });
      }
    }

  }

  /**
   * Returns how many filters are currently active within a given filter
   * group/category (used to render the count badge next to each tab in
   * the side panel, e.g. "Role & Experience  2").
   *
   * Group ids (see `filterGroups`):
   * 1 = Keyboard and Boolean Search
   * 2 = Role & Experience
   * 3 = Company
   * 4 = Skills & Expertise
   * 5 = Location
   * 6 = Education
   * 7 = Profile / Identity
   * 8 = Power Filters
   */
  getCategoryCount(groupId: number): number {
    let count = 0;
    switch (groupId) {
      case 1: // Keyboard and Boolean Search
        if (this.booleanQuery && this.booleanQuery !== '*') count++;
        break;

      case 2: // Role & Experience
        if (this.jobTitleSelectedList?.length) count++;
        if (this.pastJobTitleSelectedList?.length) count++;
        if (this.senioritySelectedList?.length) count++;
        if (this.hasValue(this.fromYearsControl?.value) || this.hasValue(this.toYearsControl?.value)) count++;
        if (this.hasValue(this.currentFromYearsControl?.value) || this.hasValue(this.currentToYearsControl?.value)) count++;
        break;

      case 3: // Company
        if (this.companySelectedList?.length) count++;
        if (this.companysizeSelectedlist?.length) count++;
        if (this.industrySelectedList?.length) count++;
        break;

      case 4: // Skills & Expertise
        if (this.skillsSelectedList?.length) count++;
        if (this.functionSelectedList?.length) count++;
        break;

      case 5: // Location
        if (this.locationSelectedList?.length) count++;
        break;

      case 6: // Education
        if (this.educationSelectedList?.length) count++;
        if (this.schoolSelectedList?.length) count++;
        if (this.fieldOfStudySelectedList?.length) count++;
        if (this.schoolLocationSelectedList?.length) count++;
        if (this.hasValue(this.fromgraduationyearControl?.value)) count++;
        if (this.hasValue(this.tograduationyearControl?.value)) count++;
        break;

      case 7: // Profile / Identity
        if (this.fullNameSelectedList?.length) count++;
        if (this.genderFormControl?.value && this.genderFormControl.value !== 'All') count++;
        break;

      case 8: // Power Filters
        if (this.highlightsSelectedList?.length) count++;
        if (this.positionhierarchyList?.length) count++;
        break;
    }
    return count;
  }

  /** True if a form control value is non-null/undefined/empty-string (usable from templates too) */
  hasValue(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
  }

  /**
   * AI Suggestions should only ever appear for Job Title, Past Job Title and Skills,
   * and only once there is data in that specific field — either text currently typed
   * into the input, OR a chip already selected for it — OR in the boolean/keyword search.
   */
  private readonly aiSuggestionFields: Record<string, { control: FormControl; selectedList: () => ChipItem[] }> = {
    jobtitle: { control: this.jobTitleControl, selectedList: () => this.jobTitleSelectedList },
    pastjobtitle: { control: this.pastJobTitleControl, selectedList: () => this.pastJobTitleSelectedList },
    skills: { control: this.skillsControl, selectedList: () => this.skillsSelectedList },
  };

  showAiSuggestionsFor(field: string): boolean {
    const config = this.aiSuggestionFields[field];
    if (!config) {
      return false;
    }
    const hasFieldData = this.hasValue(config.control.value) || (config.selectedList()?.length ?? 0) > 0;
    return hasFieldData || this.hasValue(this.booleanQuery);
  }

  // ─── Field-wise clear (clears ONE field only, e.g. just Job Title or just Skills) ───
  /** Resets the value(s) for a single field. Does NOT call getCount() — callers trigger that themselves. */
  private clearFieldValues(field: string): void {
    switch (field) {
      case 'jobtitle':
        this.jobTitleControl.setValue('');
        this.jobTitleSelectedList = [];
        this.jobTitleList = [];
        if (!this.pastJobTitleSelectedList?.length && !this.skillsSelectedList?.length) {
          this.cachedSuggestionPayload = null;
        }
        break;
      case 'pastjobtitle':
        this.pastJobTitleControl.setValue('');
        this.pastJobTitleSelectedList = [];
        this.pastjobTitleList = [];
        if (!this.jobTitleSelectedList?.length && !this.skillsSelectedList?.length) {
          this.cachedSuggestionPayload = null;
        }
        break;
      case 'seniority':
        this.seniorityControl.setValue(null);
        this.senioritySelectedList = [];
        break;
      case 'experience':
        this.fromYearsControl.setValue('');
        this.fromYearsControl.setErrors(null);
        this.toYearsControl.setValue('');
        this.toYearsControl.setErrors(null);
        break;
      case 'currentexperience':
        this.currentFromYearsControl.setValue('');
        this.currentFromYearsControl.setErrors(null);
        this.currentToYearsControl.setValue('');
        this.currentToYearsControl.setErrors(null);
        break;
      case 'company':
        this.companyControl.setValue('');
        this.companySelectedList = [];
        this.companyList = [];
        break;
      case 'companysize':
        this.companysizeControl.setValue('');
        this.companysizeSelectedlist = [];
        break;
      case 'industry':
        this.industryControl.setValue('');
        this.industrySelectedList = [];
        this.industryList = [];
        break;
      case 'skills':
        this.skillsControl.setValue('');
        this.skillsSelectedList = [];
        this.skillsList = [];
        if (!this.jobTitleSelectedList?.length && !this.pastJobTitleSelectedList?.length) {
          this.cachedSuggestionPayload = null;
        }
        break;
      case 'function':
        this.functionControl.setValue('');
        this.functionSelectedList = [];
        this.functionList = [];
        break;
      case 'location':
        this.locationControl.setValue('');
        this.locationSelectedList = [];
        this.locationList = [];
        this.locationContinents = [];
        this.continentstobeincluded = [];
        break;
      case 'distance':
        this.distanceControl.setValue(100);
        this.distanceUnitControl.setValue('kilometers');
        break;
      case 'education':
        this.educationControl.setValue('');
        this.educationSelectedList = [];
        this.educationList = [];
        break;
      case 'school':
        this.schoolControl.setValue('');
        this.schoolSelectedList = [];
        this.schoolList = [];
        break;
      case 'fieldofstudy':
        this.fieldOfStudyControl.setValue('');
        this.fieldOfStudySelectedList = [];
        this.fieldOfStudyList = [];
        break;
      case 'school_location':
        this.educationLocationControl.setValue('');
        this.schoolLocationSelectedList = [];
        this.schoolLocationList = [];
        break;
      case 'graduationyear':
        this.fromgraduationyearControl.setValue('');
        this.tograduationyearControl.setValue('');
        break;
      case 'fullname':
        this.fullNameControl.setValue('');
        this.fullNameSelectedList = [];
        this.fullNameList = [];
        this.fullNameData = [];
        this.fullnameElasticIds = [];
        this.isFullNameLinkedinUrl = false;
        break;
      case 'gender':
        this.genderFormControl.setValue('All');
        break;
      case 'highlights':
        this.highlightSelectedControl.setValue([]);
        this.highlightsSelectedList = [];
        break;
      case 'positionhierarchy':
        this.positionhierarchyControl.setValue('');
        this.positionhierarchyList = [];
        break;
      case 'booleansearch':
        this.keywordInputControl.setValue('');
        this.booleanQuery = '';
        this.booleanQueryControl.setValue('');
        break;
    }
  }

  /** Public entry point: clears just ONE field and recalculates the count. Called from each field's "Clear" link. */
  clearIndividualFilter(field: string): void {
    this.clearFieldValues(field);
    this.onUserFilterChange();
  }

  /** Resets every field across the whole panel — wired to the top "Reset All" link. */
  resetFilter(): void {
    const allFields = [
      'booleansearch', 'jobtitle', 'pastjobtitle', 'seniority', 'experience', 'currentexperience',
      'company', 'companysize', 'industry', 'skills', 'function', 'location', 'distance',
      'education', 'school', 'fieldofstudy', 'school_location', 'graduationyear',
      'fullname', 'gender', 'highlights', 'positionhierarchy'
    ];
    allFields.forEach(field => this.clearFieldValues(field));
    this.fieldSuggestions = [];
    this.cachedSuggestionPayload = null;
    this.onUserFilterChange();
  }

  /** True if any filter is currently active anywhere in the panel — used to show/hide Reset All. */
  hasActiveFilters(): boolean {
    for (let groupId = 1; groupId <= 8; groupId++) {
      if (this.getCategoryCount(groupId) > 0) {
        return true;
      }
    }
    return false;
  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  /** Handles clicks on the "Apply" dropdown-toggle button (edit mode).
   *  Skips the "Refresh Candidate Results?" confirmation dropdown — and just closes
   *  the modal directly — in two cases:
   *   1. Nothing is checked anywhere in the panel (no active filters at all), or
   *   2. Filters exist but nothing was changed since the panel opened (same as what's
   *      already applied), determined via the same hash comparison applyFilters()/
   *      updateProjectFilterResults() already use against lastAppliedFilterHash.
   *  Otherwise the native Bootstrap dropdown (data-bs-toggle="dropdown") opens as usual. */
  onApplyClick(event: MouseEvent): void {
    this.syncFilterData();
    const filterData = this.filterStoreService.getFilters();
    const currentHash = JSON.stringify(filterData);
    const noChanges = currentHash === this.lastAppliedFilterHash;

    if (noChanges) {
      // Stop the click from bubbling to Bootstrap's data-api listener on `document`,
      // which is what actually opens the dropdown-menu — this keeps it from ever showing.
      event.stopPropagation();
      event.preventDefault();
      this.dismiss();
    }
  }

  applyFilters() {

    if(this.calledFrom == 'Project-candidate-list') {

    //  const modalService = this.modalService.open(this.refreshCandidateResult, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false })
    } else {
          this.syncFilterData();

          // user changed filters after coming from insights -> drop the insights/mandatory data so the
          // recommend request is built from the current chips only (normal request)
          if (this.filtersModified) {
            this.clearInsightsFilterData();
          }

          const filterData = this.filterStoreService.getFilters();

    const currentHash = JSON.stringify(filterData);
    if (currentHash === this.lastAppliedFilterHash) {
      // nothing changed — just close the modal, skip API/navigation
      this.modelService.dismissAll();
      return;
    }
    this.lastAppliedFilterHash = currentHash;
    const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filterData)));
    localStorage.setItem(localKey, JSON.stringify(cjson.compress(filterData)));
    this.modalService.dismissAll()

    /**Method to set filter applied event */
    if(this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_UPLOAD_CANDIDATES || this.calledFrom == PROJECT_TAB_CONSTANTS.PROJECT_INBOUND_APPLICATION) {
      this.eventService.setFilterAppliedEvent(true);
      this.filterStoreService.setFilter(filterData);
    };


    if (this.type == 'edit') {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          type: this.searchType,
          key: encodeURIComponent(localKey),
          // null removes redirectSource from the URL (merge) so the request service stops applying insights logic
          ...(this.filtersModified ? { redirectSource: null } : {})
        },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    } else {
      if(this.calledFrom == 'talent-insights') {
this.router.navigate(
        ['/talent-insights/overview'],
        {
          queryParams: {
            type: 'advanced-search',
            key: encodeURIComponent(localKey)
          },
        }
      );
      } else {
  this.router.navigate(
        ['/candidate-list'],
        {
          queryParams: {
            type: 'advanced-search',
            key: encodeURIComponent(localKey)
          },
          state: { openCriteriaModal: true }
        }
      );
      }


    }
    }



  }

  showExistingFilters() {
    this.filterData = this.filterStoreService.getFilters();
    console.log(this.filterData, 'this.filterDatathis.filterDatathis.filterDatathis.filterDatathis.filterDatathis.filterData')
    this.jobTitleSelectedList = this.filterData?.jobTitleSelectedList || [];
    this.pastJobTitleSelectedList = this.filterData?.pastJobTitleSelectedList || [];
    this.skillsSelectedList = this.filterData?.skillsSelectedList || [];
    this.companySelectedList = this.filterData?.companySelectedList || [];
    this.industrySelectedList = this.filterData?.industrySelectedList || [];
    this.functionSelectedList = this.filterData?.functionSelectedList || [];

    this.locationSelectedList = this.filterData?.locationSelectedList || [];
    this.locationContinents = this.filterData?.locationcontinents || [];
    this.continentstobeincluded = this.filterData?.continentstobeincluded || [];
    this.educationSelectedList = this.filterData?.educationSelectedList || [];
    this.schoolSelectedList = this.filterData?.schoolSelectedList || [];
    this.fieldOfStudySelectedList = this.filterData?.fieldOfStudySelectedList || [];
    this.schoolLocationSelectedList = this.filterData?.schoolLocationSelectedList || [];
    this.genderFormControl.setValue(this.filterData?.gender || 'All');
    this.fromgraduationyearControl.setValue(this.filterData?.fromgraduationyear || '');
    this.tograduationyearControl.setValue(this.filterData?.tograduationyear || '');
    this.fromYearsControl.setValue(this.filterData?.yearsofexperienceFrom || '');
    this.toYearsControl.setValue(this.filterData?.yearsofexperienceTo || '');
    this.booleanQuery = this.filterData?.booleanquery != '*' ? this.filterData?.booleanquery : '';
    this.keywordInputControl.setValue(this.booleanQuery);
    this.companysizeSelectedlist = this.filterData?.companysize?.map(x => ({ key: x, chipkey: x })) || [];
    this.companysizeControl.setValue(_.pluck(this.companysizeSelectedlist, 'key'));
 this.highlightsSelectedList = (this.filterData?.profilehighlights ?? [])
  .map((v: string) => this.highLightOptions.find(option => option.value === v))
  .filter((opt: any) => !!opt)
  .map((opt: any) => ({ ...opt, key: opt.label, chipkey: opt.label }));

this.highlightSelectedControl.setValue(_.pluck(this.highlightsSelectedList, 'id'));
    this.positionhierarchyList = this.filterData?.positionhierarchy?.map(x => ({ key: x, chipkey: x })) || [];
    this.positionhierarchyControl.setValue(_.pluck(this.positionhierarchyList, 'key'));
    this.senioritySelectedList = this.filterData?.seniority?.map(x => ({ key: x, chipkey: x })) || [];
    this.seniorityControl.setValue(_.pluck(this.senioritySelectedList, 'key'));
    this.currentFromYearsControl.setValue(this.filterData?.currentfromyearsofexperience || null);
    this.currentToYearsControl.setValue(this.filterData?.currenttoyearsofexperience || null);
    this.fullNameSelectedList = this.filterData?.fullNameSelectedList || [];
    this.jobStatus.setValue(this.filterData?.jobTitleStatus == 'All' ? 'Current or Past' : this.filterData?.jobTitleStatus || 'Current');
    this.experienceStatus.setValue(this.filterData?.yearsofexperience || 'Total');
    this.industryStatus.setValue(this.filterData?.industryStatus == 'All' ? 'Current or Past' : this.filterData?.industryStatus || 'Current');
    this.companyStatus.setValue(this.filterData?.companyStatus == 'All' ? 'Current or Past' : this.filterData?.companyStatus || 'Current');
    this.distanceControl.setValue(this.filterData?.distancefromselectedlocations || 100);
    const unit = this.filterData?.distancefromselectedlocationsmeasurementunit == 'kilometers' || this.filterData?.distancefromselectedlocationsmeasurementunit == 'km' ? 'kilometers' : 'miles';
    this.distanceUnitControl.setValue(unit);
    this.exclude_persons = this.filterData?.exclude_persons;
    // this.locationContinents = this.filterData.locationcontinents;
    this.location_type = this.filterData?.location_type;
if (this.redirectSource === 'talent-insights' || this.redirectSource === 'company-insights') {
  const insights = this.filterData?.insightsFilterData;

  if (insights?.jobTitleSelectedList?.length)        this.jobTitleSelectedList.push(...insights.jobTitleSelectedList);
  if (insights?.pastJobTitleSelectedList?.length)    this.pastJobTitleSelectedList.push(...insights.pastJobTitleSelectedList);
  if (insights?.skillsSelectedList?.length)          this.skillsSelectedList.push(...insights.skillsSelectedList);
  if (insights?.companySelectedList?.length)         this.companySelectedList.push(...insights.companySelectedList);
  if (insights?.industrySelectedList?.length)        this.industrySelectedList.push(...insights.industrySelectedList);
  if (insights?.functionSelectedList?.length)        this.functionSelectedList.push(...insights.functionSelectedList);
  if (insights?.locationSelectedList?.length)        this.locationSelectedList.push(...insights.locationSelectedList);
  if (insights?.educationSelectedList?.length)       this.educationSelectedList.push(...insights.educationSelectedList);
  if (insights?.schoolSelectedList?.length)          this.schoolSelectedList.push(...insights.schoolSelectedList);
  if (insights?.fieldOfStudySelectedList?.length)    this.fieldOfStudySelectedList.push(...insights.fieldOfStudySelectedList);
  if (insights?.schoolLocationSelectedList?.length)  this.schoolLocationSelectedList.push(...insights.schoolLocationSelectedList);
    this.distanceControl.setValue(this.filterData?.insightsFilterData?.distancefromselectedlocations || 100);
    const unit = this.filterData?.insightsFilterData?.distancefromselectedlocationsmeasurementunit == 'kilometers' || this.filterData?.insightsFilterData?.distancefromselectedlocationsmeasurementunit == 'km' ? 'kilometers' : 'miles';
    this.distanceUnitControl.setValue(unit);
  if (this.filterData?.mandatoryjobtitles?.length) {
    const title = this.filterData.mandatoryjobtitles[0];
    this.jobTitleSelectedList.push({ key: title, chipkey: title, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatoryeducationalmajors?.length) {
    const major = this.filterData.mandatoryeducationalmajors[0];
    this.fieldOfStudySelectedList.push({ key: major, chipkey: major, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatoryskills?.length) {
    const skill = this.filterData.mandatoryskills[0];
    this.skillsSelectedList.push({ key: skill, chipkey: skill, isMandatory: true, isExcluded: false });
  }
  if(this.filterData?.mandatoryindustries?.length) {
    const industry = this.filterData.mandatoryindustries[0];
    this.industrySelectedList.push({ key: industry, chipkey: industry, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatoryfunctions?.length) {
    const func = this.filterData.mandatoryfunctions[0];
    this.functionSelectedList.push({ key: func, chipkey: func, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatorycompanies?.length) {
    const company = this.filterData.mandatorycompanies[0];
    this.companySelectedList.push({ key: company, chipkey: company, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatorylocations?.length) {
    const location = this.filterData.mandatorylocations[0];
    this.locationSelectedList.push({ key: location, chipkey: location, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatoryschools?.length) {
    const school = this.filterData.mandatoryschools[0];
    this.schoolSelectedList.push({ key: school, chipkey: school, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatoryseniority?.length) {
    const seniority = this.filterData.mandatoryseniority[0];
    this.senioritySelectedList.push({ key: seniority, chipkey: seniority, isMandatory: false, isExcluded: false });
  }
  if(this.filterData?.mandatoryeducationaldegrees?.length) {
    const degree = this.filterData.mandatoryeducationaldegrees[0];
    this.educationSelectedList.push({ key: degree, chipkey: degree, isMandatory: false, isExcluded: false });
  }
}
    this.getCount();
    this.lastAppliedFilterHash = JSON.stringify(this.filterData);
     const currentHash = JSON.stringify(this.filterData);
    if (currentHash === this.lastAppliedFilterHash) {
      this.showbuttonDisable = true;
    } else
    this.showbuttonDisable = false;


  }

  /** Removes everything that came from the insights redirect from the filter store (chips already hold the values). */
  private clearInsightsFilterData() {
    const arrayKeys = [
      'mandatoryjobtitles', 'mandatorylocations', 'mandatorycompanies', 'mandatoryindustries',
      'mandatoryschools', 'mandatoryfunctions', 'mandatoryeducationalmajors', 'mandatoryeducationaldegrees',
      'mandatoryseniority', 'mandatoryskills', 'insightsmandatoryskills', 'alternativecompanynames', 'lastjobcompanyids'
    ];
    arrayKeys.forEach(k => this.filterStoreService.setFilter({ [k]: [] }));
    ['recentcompanyhires', 'recentcompanyattrition', 'recentgraduatesonly']
      .forEach(k => this.filterStoreService.setFilter({ [k]: false }));
    ['insightsFilterData', 'companyid', 'winningtalent']
      .forEach(k => this.filterStoreService.setFilter({ [k]: null }));
  }

  syncFilterData() {
    this.filterStoreService.setFilter({ jobTitleSelectedList: this.jobTitleSelectedList });
    this.filterStoreService.setFilter({ pastJobTitleSelectedList: this.pastJobTitleSelectedList });
    this.filterStoreService.setFilter({ skillsSelectedList: this.skillsSelectedList });
    this.filterStoreService.setFilter({ companySelectedList: this.companySelectedList });
    this.filterStoreService.setFilter({ industrySelectedList: this.industrySelectedList });
    this.filterStoreService.setFilter({ functionSelectedList: this.functionSelectedList });
    this.filterStoreService.setFilter({ locationSelectedList: this.locationSelectedList });
    this.filterStoreService.setFilter({ locationcontinents: this.locationContinents });
    this.filterStoreService.setFilter({ continentstobeincluded: this.continentstobeincluded });
    this.filterStoreService.setFilter({ educationSelectedList: this.educationSelectedList });
    this.filterStoreService.setFilter({ schoolSelectedList: this.schoolSelectedList });
    this.filterStoreService.setFilter({ fieldOfStudySelectedList: this.fieldOfStudySelectedList });
    this.filterStoreService.setFilter({ schoolLocationSelectedList: this.schoolLocationSelectedList });
    this.filterStoreService.setFilter({ gender: this.genderFormControl.value });
    this.filterStoreService.setFilter({ fromgraduationyear: this.fromgraduationyearControl.value });
    this.filterStoreService.setFilter({ tograduationyear: this.tograduationyearControl.value });
    this.filterStoreService.setFilter({ yearsofexperienceFrom: this.fromYearsControl.value });
    this.filterStoreService.setFilter({ yearsofexperienceTo: this.toYearsControl.value });
    this.filterStoreService.setFilter({ seniority: this.senioritySelectedList.map(item => item.key) });
    this.filterStoreService.setFilter({ booleanquery: this.booleanQuery ? this.booleanQuery: this.keywordInputControl.value });
    this.filterStoreService.setFilter({ companysize: this.companysizeSelectedlist.map(item => item.key) });
    this.filterStoreService.setFilter({ profilehighlights: this.highlightsSelectedList.map(item => item.value) });
    this.filterStoreService.setFilter({ positionhierarchy: this.positionhierarchyList.map(item => item.key) });
    this.filterStoreService.setFilter({ currentfromyearsofexperience: this.currentFromYearsControl.value });
    this.filterStoreService.setFilter({ currenttoyearsofexperience: this.currentToYearsControl.value });
    this.filterStoreService.setFilter({ fullNameSelectedList: this.fullNameSelectedList });
    this.filterStoreService.setFilter({ 'jobTitleStatus': this.jobStatus.value });
    this.filterStoreService.setFilter({ 'yearsofexperience': this.experienceStatus.value });
    this.filterStoreService.setFilter({ 'companyStatus': this.companyStatus.value });
    this.filterStoreService.setFilter({ 'industryStatus': this.industryStatus.value });
    this.filterStoreService.setFilter({ 'distancefromselectedlocations': this.distanceControl.value });
    this.filterStoreService.setFilter({ 'distancefromselectedlocationsmeasurementunit': this.distanceUnitControl.value });
    this.filterStoreService.setFilter({ 'exclude_persons': this.exclude_persons });
    this.filterStoreService.setFilter({ 'include_persons': this.fullnameElasticIds });
  }

  // FILTER SCROLL
  ngAfterViewInit(): void {
    // Give DOM time to paint
    setTimeout(() => this.setupScrollObserver(), 100);
  }


  // ngOnDestroy(): void {
  //   if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
  // }

  private setupScrollObserver(): void {
    this.activeTab = this.filterGroups[0].id; // ✅ explicitly set after DOM is ready
    const container = this.scrollContainer?.nativeElement;
    if (!container) return;

    container.addEventListener('scroll', () => {
      if (this.isScrollingProgrammatically) return;
      this.updateActiveTabOnScroll();
    });
  }

  private updateActiveTabOnScroll(): void {
    const container = this.scrollContainer.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const centerY = containerRect.top + containerRect.height / 2;
    // console.log(container, containerRect, centerY, 'centry')
    let closestSection = this.filterGroups[0].id;
    let closestDistance = Infinity;

    this.sectionRefs.forEach((ref, index) => {
      const el = ref.nativeElement;
      const rect = el.getBoundingClientRect();
      const sectionCenterY = rect.top + rect.height / 2;
      const distance = Math.abs(sectionCenterY - centerY);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = this.filterGroups[index].id;
      }
    });

    if (this.activeTab !== closestSection) {
      this.activeTab = closestSection;
    }
    if (container.scrollTop === 0) {
      this.activeTab = this.filterGroups[0].id; // ✅ don't run distance math
      return;
    }
  }

  isTabReachedOrPast(tabId: string): boolean {
    const activeIndex = this.filterGroups.findIndex((t) => t.id === this.activeTab);
    const thisIndex = this.filterGroups.findIndex((t) => t.id === tabId);
    return thisIndex <= activeIndex;
  }

  scrollToSection(tabId: string): void {
    this.activeTab = tabId;
    this.isScrollingProgrammatically = true;

    const index = this.filterGroups.findIndex((t) => t.id === tabId);
    const sectionEl = this.sectionRefs.get(index)?.nativeElement;
    const container = this.scrollContainer?.nativeElement;

    if (!sectionEl || !container) return;

    const containerRect = container.getBoundingClientRect();
    const sectionRect = sectionEl.getBoundingClientRect();
    const offset = sectionRect.top - containerRect.top + container.scrollTop - containerRect.height / 2 + sectionRect.height / 2;

    container.scrollTo({ top: offset, behavior: 'smooth' });

    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.isScrollingProgrammatically = false;
    }, 800);
  }

  onMandatoryChip(chip: ChipItem, field: string) {
    this.skillsSelectedList = this.skillsSelectedList.map((c) =>
      c.key === chip.key ? { ...c, isMandatory: c.isMandatory } : c
    );
    console.log('Updated skillsSelectedList:', this.skillsSelectedList);
    this.onUserFilterChange();
  }

  selectFullName(event: any, keyboardEvent?: string, type?: string) {
    this.fullNameData = event?.option?.value;
    const fullnameValue = keyboardEvent == 'enter' ? event?.target?.value : event.option.value;
    if (keyboardEvent == 'enter' && (!fullnameValue || this.isFullNameLinkedinUrl)) {
      return;
    }
    if (keyboardEvent == 'enter') {
      this.fullNameSelectedList.push({ key: fullnameValue, chipkey: fullnameValue });
    } else {
      if (typeof fullnameValue === 'string') {
        this.fullNameSelectedList.push({ key: fullnameValue, chipkey: fullnameValue });
        this.fullnameElasticIds = [];
      } else {
        this.fullNameSelectedList.push({ key: fullnameValue?.full_name, chipkey: fullnameValue?.full_name });
        this.fullnameElasticIds.push(fullnameValue?.id);
      }

    }
    this.fullNameControl.setValue('');
    this.onUserFilterChange();

  }

  isLocationDisabled(location: any): boolean {
    if (this.filtermapperService.isHireSearchListing) {
      return this.hasEuAccess != 1 && location?.location_continent?.toLowerCase() === 'europe';
    }
    return false;
  }

  getTooltipText(location: any): string {
    if (this.isLocationDisabled(location)) {
      return 'This location cannot be selected due to GDPR regulations.\n As part of our commitment to EU data protection regulations, candidate personal data (PII) is not displayed or processed for EU-based profiles.';
    } else {
      return `${this.capitalizeFirst(location?.value)} | ${this.capitalizeFirst(location?.location_type)}`;
    }
  }

  capitalizeFirst(value: string): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  getCountForProjectCandidateList() {
    this.recCandLoader = true;
  const request = {
  projectnumber: this.projectFilterData?.projectnumber ?? null,
  projectname: this.projectFilterData?.projectname ?? null,
  status: this.projectFilterData?.status ?? null,
  jobdescription: this.projectFilterData?.jobdescription ?? null,
  parsedjobdescription: null,

  seniority: this.senioritySelectedList?.length
    ? this.senioritySelectedList?.map(item => item?.key)
    : [],

  minexperience: this.fromYearsControl?.value ?? null,
  maxexperience: this.toYearsControl?.value ?? null,

  jobtitles: this.jobTitleSelectedList?.length
    ? this.jobTitleSelectedList?.filter(x => !x?.isExcluded).map(item => item?.key)
    : [],

  excluded_jobtitles: this.jobTitleSelectedList?.length
    ? this.jobTitleSelectedList?.filter(x => x?.isExcluded).map(item => item?.key)
    : [],

  preferredskills: this.skillsSelectedList?.length
    ? this.skillsSelectedList?.filter(x => !x?.isExcluded && !x?.isMandatory).map(item => item?.key)
    : [],

  mandatoryskills: this.skillsSelectedList?.length
    ? this.skillsSelectedList?.filter(x => x?.isMandatory && !x?.isExcluded).map(item => item?.key)
    : [],

  excluded_preferredskills: this.skillsSelectedList?.length
    ? this.skillsSelectedList?.filter(x => x?.isExcluded && !x?.isMandatory).map(item => item?.key)
    : [],

  excluded_mandatoryskills: this.skillsSelectedList?.length
    ? this.skillsSelectedList?.filter(x => x?.isExcluded && x?.isMandatory).map(item => item?.key)
    : [],

  functions: this.functionSelectedList?.length
    ? this.functionSelectedList?.filter(x => !x?.isExcluded).map(item => item?.key)
    : [],

  excluded_functions: this.functionSelectedList?.length
    ? this.functionSelectedList?.filter(x => x?.isExcluded).map(item => item?.key)
    : [],

  locations: this.locationSelectedList?.length
    ? this.locationSelectedList?.filter(x => !x?.isExcluded).map(item => item?.key)
    : [],

  excluded_locations: this.locationSelectedList?.length
    ? this.locationSelectedList?.filter(x => x?.isExcluded).map(item => item?.key)
    : [],

  companies: this.companySelectedList?.length
    ? this.companySelectedList?.filter(x => !x?.isExcluded).map(item => item?.key)
    : [],

  excluded_companies: this.companySelectedList?.length
    ? this.companySelectedList?.filter(x => x?.isExcluded).map(item => item?.key)
    : [],

  industries: this.industrySelectedList?.length
    ? this.industrySelectedList?.filter(x => !x?.isExcluded).map(item => item?.key)
    : [],

  excluded_industries: this.industrySelectedList?.length
    ? this.industrySelectedList?.filter(x => x?.isExcluded).map(item => item?.key)
    : [],

  pastjobtitles: this.pastJobTitleSelectedList?.length
    ? this.pastJobTitleSelectedList?.filter(x => !x?.isExcluded).map(item => item?.key)
    : [],

  excluded_pastjobtitles: this.pastJobTitleSelectedList?.length
    ? this.pastJobTitleSelectedList?.filter(x => x?.isExcluded).map(item => item?.key)
    : [],

  schools: this.schoolSelectedList?.length
    ? this.schoolSelectedList?.map(item => item?.key)
    : [],

  educationaldegrees: this.educationSelectedList?.length
    ? this.educationSelectedList?.map(item => item?.key)
    : [],

  educationalmajors: this.fieldOfStudySelectedList?.length
    ? this.fieldOfStudySelectedList?.map(item => item?.key)
    : [],

  companysizes: this.companysizeSelectedlist?.length
    ? this.companysizeSelectedlist?.map(item => item?.key)
    : [],

  distancefromselectedlocations: this.distanceControl?.value ?? '100',
  distancefromselectedlocationsmeasurementunit: (this.distanceUnitControl?.value == 'km' || this.distanceUnitControl?.value == 'kilometers') ? 'kilometers': 'miles' ,

  profilehighlights: this.highlightsSelectedList?.length
    ? this.highlightsSelectedList?.map(item => item?.key)
    : [],

  positionhierarchies: this.positionhierarchyList?.length
    ? this.positionhierarchyList?.map(item => item?.key)
    : [],

  current_minexperience: this.currentFromYearsControl?.value != null
    ? Number(this.currentFromYearsControl?.value)
    : null,

  current_maxexperience: this.currentToYearsControl?.value != null
    ? Number(this.currentToYearsControl?.value)
    : null,

  schoollocation: this.schoolLocationSelectedList?.length
    ? this.schoolLocationSelectedList?.map(item => item?.key)
    : [],

  genders:
    this.genderFormControl?.value && this.genderFormControl?.value !== 'All'
      ? [this.genderFormControl?.value]
      : ['All'],

  companytype:
    this.companyStatus?.value === 'Current or Past'
      ? 'All'
      : (this.companyStatus?.value ?? 'Current'),

  jobtitletype:
    this.jobStatus?.value === 'Current or Past'
      ? 'All'
      : (this.jobStatus?.value ?? 'Current'),

  industrytype:
    this.industryStatus?.value === 'Current or Past'
      ? 'All'
      : (this.industryStatus?.value ?? 'Current'),

  experiencetype: this.experienceStatus?.value ?? 'Current',

  booleanquery: this.booleanQuery ?? "*",

  fromgraduationyear: this.fromgraduationyearControl?.value ?? [],
  tograduationyear: this.tograduationyearControl?.value ?? [],

  include_persons: this.fullnameElasticIds ?? [],

  fullnames: this.fullNameSelectedList?.length
    ? this.fullNameSelectedList?.map(item => item?.key)
    : [],

  eligible_count_required: true,

  continentstobeincluded:
    this.continentstobeincluded?.length && this.continentstobeincluded?.[0] != null
      ? _.uniq(this.continentstobeincluded)
      : [this.localStorageService?.getItem('defaultContinent')],

  location: this.locationSelectedList?.length
    ? this.locationSelectedList?.filter(x => !x?.isExcluded).map(item => item?.key)?.[0] ?? []
    : [],

  continent:
    this.continentstobeincluded?.length && this.continentstobeincluded?.[0] != null
      ? this.continentstobeincluded?.[0]
      : this.localStorageService?.getItem('defaultContinent')
};


const projecctnumber = location.pathname.split('/')[2]
    this.aiSourcingServices.modifyProject(request, projecctnumber).subscribe((res: any) => {
      this.recCandLoader = false;
      this.recommendCount = res.body.totalresultscount;

    });
  }

  updateProjectFilterResults() {
        this.showProjectFilterApplyLoader = true;

    this.syncFilterData();
    const filterData = this.filterStoreService.getFilters();

    const currentHash = JSON.stringify(filterData);
    if (currentHash === this.lastAppliedFilterHash) {
      this.modelService.dismissAll();
      return;
    }
    this.lastAppliedFilterHash = currentHash;
          const filter = this.filterStoreService.getFilters();

  const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filter)));
      localStorage.setItem(localKey, JSON.stringify(cjson.compress(filter)));


    const request = this.projectAggregateService.getProjectAggregateServices();
    delete request.aggregatetype;
    request['projectnumber'] = location.pathname.split('/')[2];
    request['continent'] = this.filterData?.continentstobeincluded?.length && this.filterData?.continentstobeincluded?.[0] != null ? this.filterData?.continentstobeincluded[0] : [];
    request['location'] = this.filterData?.locationSelectedList?.length && this.filterData?.locationSelectedList?.[0] != null ? this.filterData?.locationSelectedList[0]?.key : [];
    this.aggregateService.getProjectFilterApply(request).subscribe((res:any)=>{
      if(res.success == true) {
            this.modalService.dismissAll();

              this.showProjectFilterApplyLoader = false;

     this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          key: encodeURIComponent(localKey)
        },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    this.filterApplyEvent.emit({status: "success"});
      } else {
        this.modalService.dismissAll();
        this.showProjectFilterApplyLoader = false;
      }
    }, (error) => {
      this.modalService.dismissAll();
      this.showProjectFilterApplyLoader = false;
    });

  }



}
